const translations: Record<string, Record<string, string>> = {
  de: {
    'nav.master_control': 'Master Control',
    'nav.ig_parasite': 'IG Parasite',
    'nav.profile_creator': 'Profile Creator',
    'nav.logout': 'Abmelden',
    'login.title': 'Agency OS',
    'login.username': 'Benutzername',
    'login.password': 'Passwort',
    'login.submit': 'Anmelden',
    'login.error': 'Ungültige Anmeldedaten',
    'stats.total_audience': 'Gesamtreichweite',
    'stats.total_accounts': 'Accounts',
    'stats.active_niches': 'Aktive Nischen',
    'stats.avg_growth': 'Ø Wachstum',
    'stats.pending_review': 'Ausstehende Reviews',
    'stats.stale_accounts': 'Veraltete Accounts',
    'stats.posts_scraped': 'Posts gescrapt',
    'stats.rewrites': 'Rewrites',
    'tab.dashboard': 'Dashboard',
    'tab.review': 'Review Bank',
    'tab.pipeline': 'Pipeline',
    'tab.accounts': 'Accounts',
    'tab.setup': 'Profil Setup',
    'tab.feedback': 'Feedback Loop',
    'tab.settings': 'Account Settings',
    'accounts.add': 'Account hinzufügen',
    'accounts.search': 'Suche...',
    'accounts.username': 'Username',
    'accounts.followers': 'Follower',
    'accounts.growth': 'Wachstum',
    'accounts.niche': 'Nische',
    'accounts.type': 'Typ',
    'accounts.actions': 'Aktionen',
    'review.accept': 'Akzeptieren',
    'review.hide': 'Ausblenden',
    'review.skip': 'Überspringen',
    'review.set_growth': 'Growth setzen',
    'review.set_niche': 'Nische setzen',
    'review.set_type': 'Typ setzen',
    'review.empty': 'Keine Accounts zu reviewen',
    'pipeline.scrape': 'Scrapen',
    'pipeline.ocr': 'OCR starten',
    'pipeline.rewrite': 'Rewrite',
    'pipeline.assign': 'Zuweisen',
    'pipeline.scraped': 'Gescrapt',
    'pipeline.ready': 'Bereit',
    'pipeline.assigned': 'Zugewiesen',
    'pipeline.done': 'Fertig',
    'pipeline.select_niche': 'Nische wählen',
    'common.loading': 'Laden...',
    'common.save': 'Speichern',
    'common.close': 'Fertig',
    'common.saving': 'Wird gespeichert...',
    'common.cancel': 'Abbrechen',
    'common.confirm': 'Bestätigen',
    'common.delete': 'Löschen',
    'toast.scrape_started': 'Scraping gestartet...',
    'toast.scrape_done': 'Posts gescrapt',
    'toast.ocr_started': 'Bildtext wird extrahiert...',
    'toast.ocr_done': 'Bildtext extrahiert',
    'toast.rewrite_done': 'Caption umgeschrieben',
    'toast.assigned': 'Zugewiesen',
    'toast.error': 'Fehler aufgetreten',
    'profile.name': 'Profilname',
    'profile.wizard_username': 'Username & Branding',
    'profile.wizard_seo': 'SEO & Logo',
    'profile.wizard_bio': 'Bio & Beschreibung',
    'profile.wizard_launch': 'Launch Check',
    'profile.ai_sparring': 'AI Sparring',
    'nav.strategy_os': 'Strategy OS',
    'nav.activity_log': 'Activity Log',
    'nav.user_management': 'Benutzerverwaltung',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'stats.own_followers': 'Follower Gesamt',
    'stats.engagement_rate': 'Engagement Rate',
    'stats.published_week': 'Posts diese Woche',
    'master.my_accounts': 'Meine Accounts',
    'master.benchmark': 'Benchmark Accounts',
    'accounts.own_toggle': 'Eigener Account',
    'accounts.bulk_selected': 'ausgewählt',
    'accounts.bulk_action': 'Aktion wählen',
    'accounts.bulk_mark_own': 'Als eigenen Account markieren',
    'accounts.bulk_unmark_own': 'Eigener Account entfernen',
    'accounts.bulk_change_niche': 'Nische ändern',
    'accounts.bulk_change_tier': 'Tier ändern',
    'accounts.bulk_hide': 'Ausblenden',
    // Strategy OS
    'strategy.strategies': 'Strategies',
    'strategy.new_strategy': 'Neue Strategy',
    'strategy.strategy_name': 'Strategy-Name',
    'strategy.no_strategies': 'Keine Strategies',
    'strategy.create_first': 'Erstelle deine erste Strategy im Sidebar',
    'strategy.select_strategy': 'Wähle eine Strategy aus',
    'strategy.confirm_delete': 'Strategy wirklich löschen?',
    'strategy.tab.workspace': 'Workspace',
    'strategy.tab.accounts': 'Accounts',
    'strategy.tab.kits': 'Profile Kits',
    'strategy.tab.documents': 'Dokumente',
    'strategy.tab.library': 'Bibliothek',
    'strategy.tab.dashboard': 'Dashboard',
    'strategy.docs.upload': 'Hochladen',
    'strategy.docs.drop_zone': 'Dateien hier ablegen oder klicken',
    'strategy.docs.max_size': 'Max. 50 MB pro Datei',
    'strategy.docs.accepted_types': 'PDF, DOCX, XLSX, PPTX, PNG, JPG, TXT',
    'strategy.docs.extracting': 'Wird extrahiert...',
    'strategy.docs.done': 'Fertig',
    'strategy.docs.error': 'Fehler',
    'strategy.docs.reprocess': 'Erneut verarbeiten',
    'strategy.docs.delete': 'Löschen',
    'strategy.docs.download': 'Herunterladen',
    'strategy.docs.preview': 'Vorschau',
    'strategy.docs.no_text': 'Kein Text extrahiert',
    'strategy.docs.picker_title': 'Dokumente auswählen',
    'strategy.docs.select_all': 'Alle auswählen',
    'strategy.docs.select_none': 'Keine auswählen',
    'strategy.docs.confirm': 'Bestätigen',
    'strategy.docs.n_docs': '{{count}} Docs',
    'strategy.docs.include_docs': 'Dokumente einbeziehen',
    'strategy.docs.selected_count': '{{selected}}/{{total}} ausgewählt',
    'strategy.docs.no_docs': 'Keine Dokumente hochgeladen',
    'strategy.module.niche': '1. Nische',
    'strategy.module.market': '2. Markt',
    'strategy.module.avatar': '3. Avatar',
    'strategy.module.archetype': '4. Archetyp',
    'strategy.module.mvo': '5. MVO',
    'strategy.module.offer': '6. Angebot',
    'strategy.module.message': '7. Message',
    'strategy.reality_check': 'Reality Check',
    'strategy.autofill': 'Autofill',
    'strategy.iterate': 'Iterate',
    'strategy.history': 'Verlauf',
    'strategy.load_more': 'Mehr laden',
    'strategy.snapshot_banner': 'Snapshot vom',
    'strategy.field_empty': 'Feld ist leer',
    'strategy.sonnet_hint': 'Tipp: Shift+Klick für tiefere Analyse (Sonnet)',
    'strategy.no_history': 'Noch keine Reality Checks durchgeführt',
    'strategy.version_history': 'Versionsverlauf',
    'strategy.no_versions': 'Keine Versionen gespeichert',
    'strategy.restore': 'Wiederherstellen',
    'strategy.outdated_warning': 'Upstream-Modul wurde verändert · prüfe ob dieses Modul noch aktuell ist.',
    'strategy.upstream_hint': 'Basiert auf',
    'strategy.unsaved': 'Nicht gespeichert',
    'strategy.export.title': 'Ganze Strategie als Markdown exportieren',
    'strategy.export.copy': 'Kopieren',
    'strategy.export.copied': 'Kopiert',
    'strategy.export.download': 'Download .md',
    'strategy.export.preamble': '# Instagram Content-Strategie: {name}\nNische: {niche} · Sprache: {lang}\n\nDu bist mein Strategie-Berater. Unten steht die vollständige Marketing- und Content-Strategie für diesen Instagram-Account (alle Module aus dem "Strategy OS"). Nutze sie als Kontext für meine folgenden Fragen.\n\nWICHTIG für den Re-Import: Lass die Modul-Marker in eckigen Klammern (z.B. [niche]) und die Feld-Schlüssel in Backticks (z.B. `niche_name`) exakt unverändert, nur so kann die Strategie wieder importiert werden. Du darfst die Werte frei anpassen.',
    'strategy.import.button': 'Importieren',
    'strategy.import.title': 'Strategie importieren',
    'strategy.import.paste_placeholder': 'Exportierten (und in Claude bearbeiteten) Strategie-Text hier einfügen…',
    'strategy.import.preview': 'Vorschau',
    'strategy.import.apply': 'Übernehmen',
    'strategy.import.cancel': 'Abbrechen',
    'strategy.import.back': 'Zurück',
    'strategy.import.changes_count': '{modules} Module · {fields} Feld-Änderungen',
    'strategy.import.no_changes': 'Keine Änderungen erkannt. Prüfe, ob die [modul]- und `feld`-Marker noch vorhanden sind.',
    'strategy.import.unknown_keys': 'Ignoriert (unbekannte Marker): {keys}',
    'strategy.import.parse_error': 'Text konnte nicht gelesen werden. Enthält der Text noch die [modul]- und `feld`-Marker aus dem Export?',
    'strategy.import.success': 'Import übernommen, alter Stand liegt im Verlauf.',
    'strategy.import.applying': 'Übernehmen…',
    'strategy.import.old': 'alt',
    'strategy.import.new': 'neu',
    'strategy.name': 'Name',
    'strategy.status': 'Status',
    'strategy.generation': 'Gen.',
    'strategy.accounts': 'Accounts',
    'strategy.avg_er': 'Ø ER',
    'strategy.avg_growth': 'Ø Wachstum',
    'strategy.composite': 'Score',
    'strategy.composite_score': 'Composite Score',
    'strategy.no_data': 'Keine Daten',
    'strategy.strategy': 'Strategy',
    'strategy.leaderboard': 'Leaderboard',
    'strategy.merge_evolve': 'Merge & Evolve',
    'strategy.evolve': 'Evolve',
    'strategy.merge_desc': 'Wähle 2-5 Strategies zum Zusammenführen. AI extrahiert die stärksten Elemente.',
    'strategy.min_2_strategies': 'Mindestens 2 Strategies auswählen',
    'strategy.evolve_error': 'Evolution fehlgeschlagen',
    'strategy.selected': 'ausgewählt',
    'strategy.performance_over_time': 'Performance über Zeit',
    'strategy.content_heatmap': 'Content-Typ Heatmap',
    'strategy.no_chart_data': 'Noch keine Performance-Daten',
    'strategy.no_heatmap_data': 'Noch keine Heatmap-Daten',
    'strategy.signal': 'Signal',
    'strategy.noise': 'Noise',
    'strategy.signal_placeholder': 'Was funktioniert',
    'strategy.noise_placeholder': 'Was nicht',
    'strategy.profile_kits': 'Profile Kits',
    'strategy.kits_desc': '10 einzigartige IG-Profil-Konzepte basierend auf dieser Strategy',
    'strategy.generate_kits': 'Kits generieren',
    'strategy.no_kits': 'Noch keine Kits. Klicke "Kits generieren".',
    'strategy.kit.usernames': 'Username-Varianten',
    'strategy.kit.bio': 'Bio',
    'strategy.kit.pic_prompt': 'Profilbild-Prompt',
    'strategy.kit.link_strategy': 'Link-in-Bio Strategie',
    'strategy.kit.highlights': 'Highlight-Themen',
    'strategy.kit.pillars': 'Content-Pillars',
    'strategy.kit.frequency': 'Posting-Frequenz',
    'strategy.generate_kit': 'Kit generieren',
    'strategy.regenerate_kit': 'Neu generieren',
    'strategy.refine_kit': 'Verfeinern',
    'strategy.kit.personal': 'Personal Brand',
    'strategy.kit.theme': 'Theme Page',
    'strategy.kit.mixed': 'Gemischt',
    'strategy.kit.personality_traits': 'Persönlichkeitsmerkmale',
    'strategy.kit.origin_story_hook': 'Herkunfts-Hook',
    'strategy.kit.face_style_prompt': 'Gesichts-Prompt',
    'strategy.kit.color_palette': 'Farbpalette',
    'strategy.kit.brand_aesthetic': 'Markenästhetik',
    'strategy.kit.series_names': 'Content-Serien',
    'strategy.kit.starred': 'Markiert',
    'strategy.kit.preset': 'Preset',
    'strategy.kit.custom_rules': 'Eigene Regeln',
    'strategy.kit.preview_prompt': 'Prompt vorschauen',
    'strategy.kit.refine_feedback_placeholder': 'Feedback eingeben... z.B. "mehr minimalistisch"',
    'strategy.kit.generation_history': 'Generierungsverlauf',
    'strategy.kit.today_count': 'heute',
    'strategy.kit.total_count': 'gesamt',
    'strategy.kit.presets_title': 'Presets verwalten',
    'strategy.kit.add_preset': 'Preset hinzufügen',
    'strategy.kit.undo_toast': 'Rückgängig',
    'strategy.kit.model_haiku': 'Haiku (schnell)',
    'strategy.kit.model_sonnet': 'Sonnet (tief)',
    'strategy.kit.seo_name': 'SEO Name',
    'strategy.kit.include_pfp': 'Profilbild-Prompt einbeziehen',
    'strategy.kit.refine_field': 'Verfeinern',
    'strategy.kit.field_feedback_placeholder': 'Wie soll das verbessert werden?',
    'strategy.kit.apply_learned': 'Gelernte Präferenzen anwenden',
    'strategy.kit.mode_new': 'Neues Profil',
    'strategy.kit.mode_improve': 'Profil verbessern',
    'strategy.platform_assets': 'Platform Assets',
    'strategy.logo_creator': 'Logo Creator',
    'strategy.highlight_covers': 'Highlight Covers',
    'strategy.assign': 'Zuweisen',
    'strategy.unassign': 'Entfernen',
    'strategy.assign_account_placeholder': 'Username eingeben...',
    'strategy.assigned_at': 'Zugewiesen',
    'strategy.no_accounts': 'Noch keine Accounts zugewiesen',
    'strategy.swap_account': 'Konto tauschen',
    'strategy.swap_confirm': 'Konto @{old} durch @{new} ersetzen?',
    'strategy.current_account': 'Aktuelles Konto',
    'strategy.autofill_sequential': 'Sequenzielle Überprüfung',
    'strategy.autofill_improve': 'Verbessern',
    'strategy.autofill_regenerate': 'Neu generieren',
    'strategy.autofill_accept_next': 'Akzeptieren & Weiter',
    'strategy.autofill_step': 'Schritt',
    'strategy.all_categories': 'Alle Kategorien',
    'strategy.category': 'Kategorie',
    'strategy.suggest_category': 'Kategorie vorschlagen',
    'strategy.prompt_preview': 'Prompt Vorschau',
    'strategy.language': 'Sprache',
    'strategy.field.niche.niche_name': 'Nischen-Name',
    'strategy.field.niche.account_stage': 'Account Stage',
    'strategy.field.niche.profile_type': 'Profil-Typ (Unternehmensseite / persönliches Profil)',
    'strategy.field.niche.launch_proof_artifact': 'Launch-Proof (echte Zahl / Attribution für den Proof-Post)',
    'strategy.field.niche.management_type': 'Management Typ',
    'strategy.field.niche.available_assets': 'Verfügbare Assets',
    'strategy.field.avatar.audience_gender': 'Zielgruppe Geschlecht',
    'strategy.field.avatar.audience_age_range': 'Zielgruppe Alter',
    'strategy.feedback': 'Feedback',
    'strategy.add_note': 'Notiz',
    'strategy.note_placeholder': 'Notiz eingeben...',
    'strategy.feedback_history': 'Feedback-Verlauf',
    'strategy.no_feedback': 'Noch kein Feedback',
    // Content Studio
    'content_studio.tab': 'Content Studio',
    'content_studio.select_strategy': 'Strategy wählen (Pflichtfeld)',
    'content_studio.no_strategy': 'Wähle eine Strategy, um zu beginnen',
    'content_studio.tab.create': 'Erstellen',
    'content_studio.tab.history': 'Verlauf',
    'content_studio.tab.analytics': 'Analytics',
    'content_studio.tab.plan': 'Plan',
    'content_studio.tab.batch': 'Batch',
    'content_studio.tab.queue': 'Geplant',
    // Content Plan
    'plan.create_plan': 'Plan erstellen',
    'plan.plan_name': 'Plan-Name',
    'plan.cycle_type': 'Zyklus-Typ',
    'plan.cycle.weekly': 'Wöchentlich',
    'plan.cycle.biweekly': 'Zweiwöchentlich',
    'plan.cycle.monthly': 'Monatlich',
    'plan.create': 'Plan erstellen',
    'plan.since': 'seit',
    'plan.slots': 'Slots',
    'plan.no_slots': 'Keine Slots',
    'plan.add_slot': 'Slot hinzufügen',
    'plan.select_format': 'Format wählen',
    'plan.auto_adjusted': 'Auto-angepasst',
    'plan.revert': 'Zurücksetzen',
    'plan.locked_until': 'Gesperrt bis',
    'plan.today_schedule': 'Heutiger Zeitplan',
    'plan.use_slot': 'Übernehmen',
    'plan.day.monday': 'Montag',
    'plan.day.tuesday': 'Dienstag',
    'plan.day.wednesday': 'Mittwoch',
    'plan.day.thursday': 'Donnerstag',
    'plan.day.friday': 'Freitag',
    'plan.day.saturday': 'Samstag',
    'plan.day.sunday': 'Sonntag',
    'plan.time.morning': 'Morgens',
    'plan.time.afternoon': 'Nachmittags',
    'plan.time.evening': 'Abends',
    // Format Performance
    'performance.section_title': 'Format Performance',
    'performance.title': 'Performance nach Format',
    'performance.refresh': 'Aktualisieren',
    'performance.no_data': 'Noch keine Daten',
    'performance.posts': 'Posts',
    'performance.avg_likes': 'Ø Likes',
    'performance.avg_comments': 'Ø Komm.',
    'performance.er': 'ER',
    'performance.confidence': 'Konfidenz',
    'performance.suggestion_replace': 'Empfehlung: Ersetzen',
    'performance.ai_analysis': 'KI-Analyse',
    'performance.auto_adjust': 'Auto-Anpassen',
    'performance.ai_insights': 'KI-Erkenntnisse',
    'performance.top_format': 'Top-Format',
    'performance.adjust_done': 'Auto-Anpassungen',
    'content_studio.content_type': 'Content-Typ',
    'content_studio.type.hook': 'Hook',
    'content_studio.type.caption': 'Caption',
    'content_studio.type.full_post': 'Full Post',
    'content_studio.type.video_drehplan': 'Video Drehplan',
    'content_studio.type.carousel_concept': 'Carousel Konzept',
    'content_studio.type.reel': 'Reel',
    'content_studio.type.stat_post': 'Statistik',
    'content_studio.type.split_post': 'Split',
    'content_studio.type.checklist_post': 'Checkliste',
    'content_studio.type.cta': 'CTA',
    'content_studio.type.hook_reel': 'Hook-Reel',
    'content_studio.type.b_roll_reel': 'B-Roll-Reel',
    'content_studio.type.talking_head': 'Talking Head',
    'content_studio.type.tutorial_reel': 'Tutorial',
    'content_studio.type.stat_reel': 'Statistik-Reel',
    'content_studio.type.story_reel': 'Story-Reel',
    'content_studio.type.cta_reel': 'CTA-Reel',
    'content_studio.format.image': 'Bild',
    'content_studio.format.video': 'Video',
    'content_studio.context_sources': 'Kontext-Quellen',
    'content_studio.use_strategy_context': 'Strategy-Kontext',
    'content_studio.use_niche_directive': 'Nischen-Direktive',
    'content_studio.use_competitor_posts': 'Competitor Posts',
    'content_studio.competitor_posts_label': 'Competitor Referenz',
    'content_studio.style_preset': 'Style Preset',
    'content_studio.no_preset': 'Kein Preset',
    'content_studio.custom_rules': 'Eigene Regeln',
    'content_studio.custom_rules_placeholder': 'z.B. "Maximal 100 Wörter, auf Deutsch"',
    'content_studio.model_haiku': 'Haiku (schnell)',
    'content_studio.model_sonnet': 'Sonnet (tief)',
    'content_studio.preview_prompt': 'Prompt vorschauen',
    'content_studio.generate': 'Generieren',
    'content_studio.generating': 'Generiert...',
    'content_studio.refine': 'Verfeinern',
    'content_studio.refining': 'Verfeinert...',
    'content_studio.regenerate': 'Neu generieren',
    'content_studio.copy': 'Kopieren',
    'content_studio.copied': 'Kopiert!',
    'content_studio.star': 'Markieren',
    'content_studio.open_in_live': 'Im Live-Tab öffnen',
    'content_studio.open_in_reel_builder': 'Im Reel-Builder öffnen',
    'content_studio.mark_posted': 'Als gepostet markieren',
    'content_studio.rate_good': '👍 Gut',
    'content_studio.rate_bad': '👎 Schlecht',
    'content_studio.rate_adjust': '🔧 Anpassen',
    'content_studio.refine_placeholder': 'Feedback eingeben...',
    'content_studio.history_empty': 'Noch keine Generierungen',
    'content_studio.filter_all': 'Alle Typen',
    'content_studio.filter_starred': 'Nur markierte',
    'content_studio.posted_url': 'Instagram Post URL',
    'content_studio.scrape_intervals': 'Engagement-Check',
    'content_studio.interval_24h': '24 Stunden',
    'content_studio.interval_72h': '72 Stunden',
    'content_studio.interval_7d': '7 Tage',
    'content_studio.mark_posted_submit': 'Als gepostet speichern',
    'content_studio.engagement.likes': 'Likes',
    'content_studio.engagement.comments': 'Kommentare',
    'content_studio.engagement.views': 'Views',
    'content_studio.engagement.er': 'Engagement Rate',
    'content_studio.engagement.pending': 'Noch nicht gescrapt',
    'content_studio.analytics.total': 'Gesamt',
    'content_studio.analytics.good': 'Gut',
    'content_studio.analytics.bad': 'Schlecht',
    'content_studio.analytics.adjust': 'Anpassen',
    'content_studio.no_output': 'Kein Output vorhanden',
    'content_studio.no_account_assigned': 'Kein Account zugewiesen',
    'content_studio.select_channel': 'Instagram-Kanal wählen',
    'content_studio.no_linked_account': 'Kanal hat keinen verknüpften Account',
    'content_studio.link_account': 'Account verknüpfen',
    'content_studio.unlink_account': 'Verknüpfung lösen',
    'content_studio.select_account_to_link': 'Account zum Verknüpfen wählen',
    'content_studio.no_accounts_available': 'Keine Accounts verfügbar',
    'content_studio.version': 'v',
    'content_studio.generate_image': 'Bild generieren',
    'content_studio.select_template': 'Template wählen',
    'content_studio.image_url_placeholder': 'Bild-URL (optional)',
    'content_studio.download_image': 'Bild herunterladen',
    'content_studio.generating_image': 'Generiert Bild...',
    'content_studio.try_another': 'Anderes Template',
    'content_studio.image_error': 'Bild konnte nicht generiert werden.',
    'content_studio.error_details': 'Details',
    'content_studio.change_url': 'URL ändern',
    'content_studio.change_template': 'Template ändern',
    'content_studio.apply': 'Anwenden',
    'content_studio.image_mode_none': 'Kein Bild',
    'content_studio.image_mode_single': 'Ein Bild',
    'content_studio.image_mode_dual': 'Zwei Bilder',
    'content_studio.image_left': 'Bild links',
    'content_studio.image_right': 'Bild rechts',
    'content_studio.ai_recommended': 'AI empfohlen',
    'content_studio.tab_stock': 'Stock',
    'content_studio.tab_ai': 'AI',
    'content_studio.tab_url': 'URL',
    'content_studio.load_more': 'Mehr laden',
    'content_studio.ai_prompt_placeholder': 'FLUX Prompt...',
    'content_studio.ai_model_schnell': 'Schnell (~2s)',
    'content_studio.ai_model_dev': 'Dev (~20s, HD)',
    'content_studio.ai_generate': 'Generieren',
    'content_studio.ai_use': 'Verwenden',
    'content_studio.ai_estimated_fast': 'Ca. 2 Sekunden...',
    'content_studio.ai_estimated_slow': 'Ca. 20 Sekunden...',
    'content_studio.ai_gen_retry': 'Erneut versuchen',
    'content_studio.ai_gen_open_dashboard': 'FAL Dashboard öffnen',
    'content_studio.carousel.template': 'Template',
    'content_studio.carousel.no_template': 'Kein Template',
    'content_studio.carousel.hook': 'Hook',
    'content_studio.carousel.cta': 'CTA',
    'content_studio.carousel.rewrite_slide': 'Neu schreiben',
    'content_studio.carousel.generate_image': 'Bild erstellen',
    'content_studio.carousel.insert_after': '+ Slide',
    'content_studio.carousel.caption_label': 'Caption',
    'content_studio.carousel.hashtags_label': 'Hashtags',
    'content_studio.carousel.save_caption': 'Speichern',
    'content_studio.carousel.rewrite_caption': 'Caption ↻',
    'content_studio.carousel.confirm_template_change': 'Template wechseln löscht alle erstellten Bilder. Fortfahren?',
    'content_studio.carousel.stale_banner': 'Brand geändert seit letztem Render. Neu rendern zum Aktualisieren.',
    'content_studio.layout.split': 'Split',
    'content_studio.layout.overlay': 'Overlay',
    'content_studio.layout.card': 'Card',
    'content_studio.layout.minimal_gradient': 'Gradient',
    'content_studio.layout.vertical_split': 'Vertikal',
    'content_studio.layout.sticky_note': 'Notiz',
    'content_studio.layout.checklist': 'Checkliste',
    'content_studio.layout.logo': 'Logo',
    'content_studio.layout.default': 'Standard',
    'content_studio.no_stock_results': 'Keine Ergebnisse gefunden.',
    'content_studio.suggest_alternatives': 'Alternativen vorschlagen',
    'content_studio.alt_loading': 'Lade Alternativen...',
    'stock_search.results_from': 'Ergebnisse von {source}',
    'stock_search.fallback_used': '{primary} nicht verfügbar, zeige {fallback}-Ergebnisse',
    'stock_search.not_configured': 'Stock-Photo-API nicht konfiguriert',
    'stock_search.auth_failed': 'API-Schlüssel ungültig',
    'stock_search.rate_limited': 'Rate Limit erreicht, versuche es später',
    'stock_search.api_error': 'API-Fehler',
    'stock_search.network_error': 'Netzwerkfehler',
    'stock_search.enrichment_failed': 'Keyword-Optimierung fehlgeschlagen',
    // Outreach
    'outreach.phase.kalt': 'Kalt',
    'outreach.phase.interesse': 'Interesse',
    'outreach.phase.vertiefung': 'Vertiefung',
    'outreach.phase.closing': 'Closing',
    // Beziehungszustaende (S3). Die alten Phasen bleiben daneben stehen — die Extension und die
    // Altansichten sprechen weiter Phase.
    'outreach.state.nicht_verbunden': 'Nicht verbunden',
    'outreach.state.angefragt': 'Angefragt',
    'outreach.state.abgelehnt': 'Abgelehnt',
    'outreach.state.verbunden': 'Verbunden',
    'outreach.state.angeschrieben': 'Angeschrieben',
    'outreach.state.geghosted': 'Geghosted',
    'outreach.state.geantwortet': 'Geantwortet',
    'outreach.state.termin': 'Termin',
    'outreach.substate.konkrete_frage': 'Konkrete Frage',
    'outreach.substate.legitimitaetstest': 'Legitimitätstest',
    'outreach.substate.gegenfrage': 'Gegenfrage',
    'outreach.substate.persoenliche_oeffnung': 'Persönliche Öffnung',
    'outreach.substate.einwand_preis': 'Einwand Preis',
    'outreach.substate.einwand_timing': 'Einwand Timing',
    'outreach.substate.einwand_fit': 'Einwand Fit',
    'outreach.substate.weiterleitung': 'Weiterleitung',
    'outreach.substate.absage': 'Absage',
    'outreach.state.empty': 'Für diesen Zustand gibt es noch keine Texte.',
    'outreach.state.oldPhase': 'Alte Phase',
    'outreach.state.connectors': 'Konnektoren (passen in jeden Zustand)',
    // Merker (S5) — eigene Achse, keine Zustände. Sie treten ZUSAMMEN mit einem Zustand auf.
    'outreach.marker.label': 'Merker',
    'outreach.marker.eingehend': 'Eingehend',
    'outreach.marker.nur_reagiert': 'Nur reagiert',
    'outreach.marker.kurz_angebunden': 'Kurz angebunden',
    'outreach.marker.gelesen_ohne_antwort': 'Gelesen ohne Antwort',
    'outreach.marker.hint': 'Merker setzen — ändert den Zustand nicht',
    'outreach.marker.remove': 'Merker wegnehmen',
    // Der Weg zurück. Die Beschriftung sagt ausdrücklich, dass die Phase stehen bleibt — der
    // Server nimmt nur den Zustand zurück, so entschieden in db_web/outreach.py.
    'outreach.state.reset': 'Zustand wieder ableiten',
    'outreach.state.resetKeepsPhase': 'Phase bleibt bei {phase}',
    'outreach.stats.byState': 'Nach Beziehungszustand',
    'outreach.stats.sameTargets': 'dieselben {n} Ziele wie oben',
    'outreach.review.title': 'Wie war die Reaktion?',
    'outreach.review.fire': 'Super',
    'outreach.review.ok': 'Ok',
    'outreach.review.weak': 'Schwach',
    'outreach.review.no_reply': 'Keine Antwort',
    'outreach.review.their_response': 'Was hat die Person geantwortet? (optional)',
    'outreach.review.saved': 'Bewertung gespeichert!',
    'outreach.review.not_sent': 'Doch nicht gesendet (rückgängig)',
    'outreach.used_badge': '{count}\u00d7 diese Woche',
    'outreach.platform.linkedin': 'LinkedIn',
    'outreach.platform.email': 'E-Mail',
    'outreach.platform.instagram': 'Instagram',
    'outreach.platform.andere': 'Andere',
    'outreach.platform.add': 'Plattform hinzufügen',
    'outreach.style.casual': 'Casual',
    'outreach.style.professional': 'Professional',
    'outreach.style.direkt': 'Direkt',
    'outreach.style.empathisch': 'Empathisch',
    'outreach.enrichment.ig_profile': 'IG Profil',
    'outreach.enrichment.website': 'Website',
    'outreach.enrichment.competitors': 'Wettbewerb',
    'outreach.enrichment.strategy': 'Strategie',
    'outreach.enrichment.upload_screenshot': 'Screenshot hochladen',
    'outreach.enrichment.analyze': 'Analysieren',
    'outreach.enrichment.history': 'History',
    'outreach.enrichment.notes': 'Notizen',
    'outreach.enrichment.auto_fetch': 'Auto-Fetch',
    'outreach.enrichment.manual': 'Manuell',
    'outreach.enrichment.search_competitors': 'Suchen',
    'outreach.enrichment.linked': 'verlinkt',
    'outreach.enrichment.analyzed': 'analysiert',
    'outreach.enrichment.competitors_found': '{count} Konkurrenten',
    'outreach.enrichment.loading': 'Wird analysiert...',
    'outreach.target.new': 'Neue Firma anlegen',
    'outreach.target.company_name': 'Firmenname',
    'outreach.target.ig_username': 'IG Username',
    'outreach.target.platforms': 'Plattformen',
    'outreach.target.strategy': 'Strategie',
    'outreach.target.website': 'Website',
    // Sales CRM
    'nav.sales_crm': 'Sales CRM',
    'nav.outreach': 'Business Outreach',
    'sales.listbuilding': 'Listbuilding',
    'sales.tracking': 'Sales Tracking',
    'sales.add_lead': 'Lead hinzufügen',
    'sales.call': 'Anrufen',
    'sales.start_call': 'Call starten',
    'sales.submit_call': 'Call speichern',
    'sales.update_status_prompt': 'Lead-Status aktualisieren?',
    'sales.follow_up_date': 'Follow-up Datum',
    'sales.script_editor': 'Script bearbeiten',
    'sales.kpi.total_calls': 'Calls gesamt',
    'sales.kpi.won': 'Gewonnen',
    'sales.kpi.lost': 'Verloren',
    'sales.kpi.conversion': 'Conversion %',
    'sales.emotion.warm': 'Warm',
    'sales.emotion.neutral': 'Neutral',
    'sales.emotion.cold': 'Kalt',
    'sales.emotion.hostile': 'Feindlich',
    'sales.source.linkedin': 'LinkedIn',
    'sales.source.instagram': 'Instagram',
    'sales.source.referral': 'Empfehlung',
    'sales.source.cold': 'Kalt',
    'sales.source.website': 'Website',
    'sales.status.new': 'Neu',
    'sales.status.called': 'Angerufen',
    'sales.status.follow_up': 'Follow-up',
    'sales.status.won': 'Gewonnen',
    'sales.status.lost': 'Verloren',
    'sales.pre_call_summary': 'Vor dem Call',
    'sales.no_previous_calls': 'Erster Anruf',
    'sales.script_save': 'Script speichern',
    'sales.version_history': 'Versionshistorie',
    'sales.restore_version': 'Wiederherstellen',
    // Module field labels
    'strategy.field.niche.problemsAndDesires': 'Probleme, Ängste und Wünsche pro Nische',
    'strategy.field.niche.mostPowerfulProblem': 'Das eine stärkste Problem oder Wunsch',
    'strategy.field.niche.transformationBefore': 'Ausgangszustand (vorher) · wo sind sie jetzt?',
    'strategy.field.niche.transformationAfter': 'Zielzustand (nachher) · wo wollen sie hin?',
    'strategy.field.market.q1': 'Was hält sie nachts wach?',
    'strategy.field.market.q2': 'Wovor haben sie Angst?',
    'strategy.field.market.q3': 'Worüber sind sie wütend? Auf wen?',
    'strategy.field.market.q4': 'Top 3 tägliche Frustrationen',
    'strategy.field.market.q5': 'Welche Trends gibt es in ihrem Bereich?',
    'strategy.field.market.q6': 'Was wünschen sie sich heimlich am meisten?',
    'strategy.field.market.q7': 'Gibt es eine eingebaute Bias bei ihren Entscheidungen?',
    'strategy.field.market.q8': 'Haben sie ihre eigene Sprache oder Jargon?',
    'strategy.field.market.q9': 'Wer verkauft ähnliches? Wie?',
    'strategy.field.market.q10': 'Wer hat ähnliches versucht und ist gescheitert? Warum?',
    'strategy.field.avatar.name': 'Avatar-Name (z.B. "Anna Avatar")',
    'strategy.field.avatar.occupation': 'Beruf oder Beschreibung',
    'strategy.field.avatar.location': 'Wo leben sie?',
    'strategy.field.avatar.age': 'Wie alt sind sie?',
    'strategy.field.avatar.education': 'Bildungsniveau',
    'strategy.field.avatar.accomplishments': 'Was haben sie erreicht?',
    'strategy.field.avatar.weeklyRoutine': 'Wie verbringen sie ihre Woche?',
    'strategy.field.avatar.outsideWork': 'Was tun sie außerhalb der Arbeit?',
    'strategy.field.avatar.newsSources': 'Woher beziehen sie Informationen?',
    'strategy.field.avatar.income': 'Wie viel verdienen sie?',
    'strategy.field.avatar.jobFeelings': 'Wie fühlen sie sich bei der Arbeit?',
    'strategy.field.avatar.lifeConcerns': 'Was sind ihre Lebenssorgen?',
    'strategy.field.avatar.marketingPersonality': 'Persönlichkeitsaspekte die das Marketing beeinflussen',
    'strategy.field.avatar.backstory': 'Vergangene Ereignisse die zu diesem Punkt geführt haben',
    'strategy.field.avatar.pastFeelings': 'Wie sie sich über die Vergangenheit fühlen',
    'strategy.field.avatar.currentInterests': 'Wofür sie sich aktuell interessieren',
    'strategy.field.avatar.relationshipStatus': 'Verheiratet/geschieden/Single/Kinder?',
    'strategy.field.avatar.familyImpact': 'Wie die Familie die Produktnutzung beeinflusst',
    'strategy.field.avatar.whyProductMatters': 'Wie löst dein Produkt ihr Problem?',
    'strategy.field.avatar.purchaseTrigger': 'Was ist der "letzte Strohhalm" der sie kaufen lässt?',
    'strategy.field.archetype.failure_scene': 'Was ist die exakte Szene des Scheiterns? (EIN konkreter Moment, Präsens, max. 2 Sätze)',
    'strategy.field.archetype.identity_tension': 'Was glaubt der Viewer über sich, das seinen Ergebnissen widerspricht?',
    'strategy.field.archetype.insight_gap': 'Was ist der Viewer nicht bereit zuzugeben?',
    'strategy.field.archetype.winning_scene': 'Wie sieht "Gewinnen" als konkrete, visuelle Szene aus?',
    'strategy.field.mvo.niche': 'Was ist die Nische?',
    'strategy.field.mvo.currentSituation': 'Aktuelle Situation',
    'strategy.field.mvo.desiredSituation': 'Gewünschte Situation',
    'strategy.field.mvo.costOfStaying': 'Was kostet es ihnen zu bleiben?',
    'strategy.field.mvo.worthOfGetting': 'Was wäre es wert dort hinzukommen?',
    'strategy.field.mvo.whatParticipantsDo': 'Was machen die meisten Teilnehmer? Wie gut?',
    'strategy.field.mvo.whatProvidersDo': 'Was bieten Anbieter an? Wie gut?',
    'strategy.field.mvo.whatCrushersDo': 'Was machen die Top-Performer? Was ist anders?',
    'strategy.field.offer.niche': 'Was ist die Nische?',
    'strategy.field.offer.currentSituation': 'Aktuelle Situation',
    'strategy.field.offer.desiredSituation': 'Gewünschte Situation',
    'strategy.field.offer.versionNumber': 'Versionsnummer',
    'strategy.field.offer.signalVsNoise': 'Signal vs. Noise',
    'strategy.field.offer.minimumWork': 'Minimale Arbeit für die Transformation',
    'strategy.field.offer.price': 'Fairer aber hoher Preis',
    'strategy.field.offer.certaintyOfNiche': 'Wie sicher bist du bei dieser Nische? (1-10)',
    'strategy.field.offer.painLevel': 'Wie schmerzhaft ist ihre aktuelle Situation? (1-10)',
    'strategy.field.offer.urgencyLevel': 'Wie dringend ist ihr Wunsch? (1-10)',
    'strategy.field.offer.complexityLevel': 'Wie komplex ist die Lösung? (1=komplex, 10=einfach)',
    'strategy.field.offer.possibilityLevel': 'Wie erreichbar ist die gewünschte Situation? (1-10)',
    'strategy.field.offer.timeframeDays': 'Zeitrahmen in Tagen',
    'strategy.field.offer.separator': 'Teil 2: Live-Markt-Feedback',
    'strategy.field.offer.offersCount': 'Anzahl gemachter Angebote (Ziel: 30+)',
    'strategy.field.offer.objections': 'Welche Einwände gibt der Markt?',
    'strategy.field.offer.thingsLiked': 'Was findet der Markt gut?',
    'strategy.field.offer.conversationConclusions': 'Wie enden die Gespräche?',
    'strategy.field.offer.emergingPatterns': 'Welche Muster tauchen immer wieder auf?',
    'strategy.field.offer.improvements': 'Verbesserungsideen',
    'strategy.field.message.niche': 'Was ist die Nische?',
    'strategy.field.message.currentSituation': 'Aktuelle Situation',
    'strategy.field.message.desiredSituation': 'Gewünschte Situation',
    'strategy.field.message.versionNumber': 'Versionsnummer',
    'strategy.field.message.nicheLanguage': 'Sprache/Slang der Nische',
    'strategy.field.message.messageEquation': '"Ich helfe [Nische] [Ergebnis zu erreichen] durch [Angebot]"',
    'strategy.field.message.preResonanceScore': 'Resonanz-Bewertung vor Feedback (1-10)',
    'strategy.field.message.separator': 'Teil 2: Live-Markt-Feedback',
    'strategy.field.message.offersCount': 'Anzahl gemachter Angebote',
    'strategy.field.message.repeatedPhrases': 'Wörter/Phrasen die Prospects wiederholen',
    'strategy.field.message.recurringStories': 'Geschichten die sich wiederholen',
    'strategy.field.message.metaphorsUsed': 'Metaphern/Analogien die Prospects nutzen',
    'strategy.field.message.boredTopics': 'Was langweilt oder traurig macht',
    'strategy.field.message.excitedTopics': 'Was begeistert oder Energie gibt',
    'strategy.field.message.wordsNotResonated': 'Deine Wörter die NICHT ankamen',
    'strategy.field.message.wordsResonated': 'Deine Wörter die ankamen',
    'strategy.field.message.bestMetaphors': 'Deine besten Metaphern/Analogien',
    'strategy.field.message.postResonanceScore': 'Resonanz-Bewertung nach Feedback (1-10)',
    'strategy.field.message.improvements': 'Verbesserungsideen',
    // Visual Identity module
    'strategy.module.visual': 'Visual Identity',
    'strategy.field.visual.visual_style': 'Visual Style',
    'strategy.field.visual.photo_style': 'Photo Style',
    'strategy.field.visual.preferred_templates': 'Bevorzugte Templates',
    'strategy.field.visual.color_usage': 'Farbverwendung',
    'strategy.field.visual.image_mood': 'Bild-Stimmung',
    'strategy.field.visual.content_format_mix': 'Content Format Mix',
    'strategy.field.visual.photo_pool': 'Foto-Pool',
    'strategy.field.visual.use_photos_for_carousel': 'Eigene Fotos fuer Karussell-Hook (Slide 1)',
    'strategy.field.visual.photo_pool_source': 'Foto-Quelle',
    'strategy.field.visual.photo_pool_drive_folder_id': 'Google Drive Ordner-ID',
    'strategy.field.visual.photo_overlay_opacity': 'Overlay-Deckkraft',
    'strategy.field.visual.logo_url': 'Logo',
    'strategy.field.visual.logo_shape': 'Logo-Form',
    'strategy.field.visual.logo_border_width': 'Logo-Rahmenbreite',
    'strategy.field.visual.logo_border_color': 'Logo-Rahmenfarbe',
    'strategy.field.visual.logo_size': 'Logo-Größe',
    'strategy.field.visual.brand_identity': 'Markenidentität',
    'strategy.field.visual.brand_aesthetic': 'Brand-Ästhetik',
    'strategy.field.visual.face_style_prompt': 'Gesichtsstil',
    'strategy.field.visual.profile_pic_prompt': 'Profilbild-Guide',
    'strategy.field.visual.color_palette': 'Markenfarben',
    'content_studio.logo_settings': 'Logo-Einstellungen',
    'content_studio.logo_size': 'Logo-Größe',
    'content_studio.border_width': 'Rahmenbreite',
    'content_studio.border_color': 'Rahmenfarbe',
    // Audit
    'audit.tab': 'Audit',
    'audit.generate_tab': 'Generieren',
    'audit.history_tab': 'Verlauf',
    'audit.upload_profile': 'Profil-Screenshot',
    'audit.upload_feed': 'Feed Grid (optional)',
    'audit.drop_hint': 'Klicken, ziehen oder Cmd+V',
    'audit.run_button': 'Profil auditieren',
    'audit.overall_score': 'Gesamt-Score',
    'audit.top_priorities': 'Top Prioritäten',
    'audit.status_green': 'Gut',
    'audit.status_yellow': 'Verbesserbar',
    'audit.status_red': 'Kritisch',
    'audit.status_concern': 'Strategie-Konflikt',
    'audit.apply': 'Übernehmen',
    'audit.refine': 'Mit KI verfeinern',
    'audit.feed_analysis': 'Feed-Analyse',
    'audit.no_audits': 'Noch keine Audits',
    'audit.loading': 'Analysiere...',
    'audit.current_profile': 'Aktuelles Profil',
    'audit.current_profile_empty': 'Noch keine Profildaten · Audit durchführen oder manuell eingeben',
    'audit.current_profile_source': 'Quelle',
    'audit.action_to_kit': '→ Ins Kit',
    'audit.action_implemented': '✓ Umgesetzt',
    'audit.action_dismiss': 'Verwerfen',
    'audit.action_custom': 'Anpassen',
    'audit.implementation_score': '{done}/{total} umgesetzt',
    'audit.custom_placeholder': 'Eigene Version...',
    'audit.improve_disabled': 'Erstelle zuerst ein Profil via Screenshot-Audit oder füge Felder manuell hinzu',
    'audit.seo_chars': '{n}/64 Zeichen',
    'audit.seo_too_long': 'Max. 64 Zeichen!',
    'audit.save': 'Speichern',
    'audit.profile_screenshot': 'Profil-Screenshot',
    'audit.feed_screenshot': 'Feed Grid (optional)',
    'audit.run': 'Profil auditieren',
    'audit.field_results': 'Felder',
    'audit.show_history': 'Verlauf anzeigen',
    'audit.no_history': 'Noch keine Audits',
    'audit.platform_instagram': 'Instagram',
    'audit.platform_linkedin': 'LinkedIn',
    'audit.platform_landingpage': 'Landingpage',
    'audit.optimization': 'Optimierung',
    'audit.strategy_fit': 'Strategy Fit',
    'audit.lp_url_label': 'URL eingeben',
    'audit.lp_url_placeholder': 'https://deine-seite.de',
    'audit.lp_loading_screenshot': 'Screenshot wird erstellt...',
    'audit.lp_screenshot': 'Screenshot (Pflicht)',
    'audit.banner_upload': 'Banner (optional)',
    'audit.concern_warning': 'Diese Änderung steht im Konflikt mit deiner Strategie. Trotzdem übernehmen?',
    'audit.concern_confirm': 'Trotzdem übernehmen',
    'audit.concern_cancel': 'Abbrechen',
    'audit.field_headline': 'Headline',
    'audit.field_about': 'About',
    'audit.field_featured': 'Featured',
    'audit.field_banner': 'Banner',
    'audit.field_subheadline': 'Subheadline',
    'audit.field_cta': 'Call to Action',
    'audit.field_social_proof': 'Social Proof',
    'audit.field_visual_identity': 'Visuelles Branding',
    'audit.field_conversion_structure': 'Conversion-Struktur',
    'audit.field_strategy_alignment': 'Strategie-Alignment',
    'profile_overview.title': 'Mein Profil',
    'profile_overview.empty': 'Noch kein Profil. Generiere ein Kit und übernimm Felder.',
    'profile_overview.remove': 'Entfernen',
    'profile_overview.edit': 'Bearbeiten',
    'profile_overview.save': 'Speichern',
    'profile_overview.adopted': 'Übernommen',
    'profile_overview.last_audit': 'Letzter Audit',
    'profile_overview.no_audit': 'Kein Audit',
    'profile_overview.add_field': 'Feld hinzufügen',
    'profile_overview.select_field': 'Feld wählen...',
    'profile_overview.cancel': 'Abbrechen',
    'settings.branding_title': 'Branding',
    'settings.app_name': 'App-Name',
    'settings.logo': 'Logo',
    'settings.upload_logo': 'Logo hochladen',
    'settings.primary_color': 'Primärfarbe',
    'settings.accent_color': 'Akzentfarbe',
    'settings.save': 'Speichern',
    'settings.saved': 'Gespeichert',
    'brand.profile': 'Profil',
    'brand.channels': 'Kanäle',
    'brand.competitors': 'Konkurrenten',
    'brand.display_name': 'Brand-Name',
    'brand.entity_type': 'Typ',
    'brand.industry': 'Branche',
    'brand.website': 'Webseite',
    'brand.description': 'Beschreibung',
    'brand.entity_person': 'Person',
    'brand.entity_business': 'Unternehmen',
    'brand.entity_brand': 'Brand',
    'brand.add_channel': 'Kanal hinzufügen',
    'brand.edit_channel': 'Kanal bearbeiten',
    'brand.set_primary': 'Als primär setzen',
    'brand.remove_channel': 'Kanal entfernen',
    'brand.primary': 'Primär',
    'brand.platform_instagram': 'Instagram',
    'brand.platform_youtube': 'YouTube',
    'brand.platform_linkedin': 'LinkedIn',
    'brand.platform_tiktok': 'TikTok',
    'brand.platform_website': 'Webseite',
    'brand.platform_landing_page': 'Landing Page',
    'brand.add_competitor': 'Konkurrent hinzufügen',
    'brand.remove_competitor': 'Konkurrent entfernen',
    'brand.scraping': 'Scraping...',
    'brand.scrape_apify': 'Via Apify scrapen',
    'brand.check_account': 'Account prüfen',
    'brand.account_exists': 'bereits vorhanden',
    'brand.account_not_found': 'nicht gefunden',
    'brand.benchmark': 'Benchmark',
    'brand.benchmark_better': 'Besser',
    'brand.benchmark_worse': 'Schlechter',
    'brand.create_new': 'Neue Brand erstellen',
    'brand.select_existing': 'Bestehende Brand auswählen',
    'brand.no_brand': 'Keine Brand verknüpft',
    'brand.no_channels': 'Noch keine Kanäle',
    'nav.integrations': 'Integrationen',
    'integrations.title': 'Integrationen',
    'integrations.connected_accounts': 'Verbundene Accounts',
    'integrations.ig_connect': 'Instagram verbinden',
    'integrations.ig_connect_other': 'Anderen Account verbinden',
    'integrations.ig_disconnect': 'Trennen',
    'integrations.ig_connected_success': 'Instagram erfolgreich verbunden!',
    'integrations.ig_connect_error': 'Verbindung fehlgeschlagen. Bitte versuche es erneut.',
    'integrations.ig_no_connections': 'Keine Instagram-Accounts verbunden.',
    'integrations.ig_publish_history': 'Veröffentlichungsverlauf',
    'integrations.ig_token_active': 'Aktiv',
    'integrations.ig_token_expiring': 'Läuft bald ab',
    'integrations.ig_token_expired': 'Abgelaufen',
    'content_studio.publish_ig': 'Auf IG posten',
    'content_studio.publish_ig_publishing': 'Wird gepostet...',
    'content_studio.publish_ig_success': 'Auf Instagram veröffentlicht!',
    'content_studio.publish_ig_failed': 'Posten fehlgeschlagen',
    'content_studio.publish_ig_select_account': 'Account wählen',
    'content_studio.publish_ig_already_published': 'Bereits veröffentlicht',
    'content_studio.trending_audio_tip': 'Tipp: Carousels mit Trending-Audio haben eine Chance, im Reels-Tab zu erscheinen (bis zu 10x Reichweite). Audio muss manuell in Instagram ausgewählt werden.',
    'content_studio.trending_audio_link': 'Trending-Audio finden',
    // Satellite OS
    'nav.satellite_os': 'Satellite OS',
    // Content Vault
    'nav.vault': 'Content Vault',
    'nav.trending_music': 'Trending Music',
    'nav.reels': 'Reels',
    'nav.contact_pool': 'Contact Pool',
    'nav.group_content_engine': 'Content Engine',
    'nav.group_strategy': 'Strategie',
    'nav.group_sales_outreach': 'Sales & Outreach',
    'nav.group_system': 'System',
    'satellite.tab.dashboard': 'Dashboard',
    'satellite.tab.detail': 'Detail',
    'satellite.tab.leads': 'Lead Funnel',
    'satellite.status.setup': 'Setup',
    'satellite.status.growing': 'Wachstum',
    'satellite.status.monetizing': 'Monetarisierung',
    'satellite.status.sold': 'Verkauft',
    'satellite.status.archived': 'Archiviert',
    'satellite.fork_button': 'Fork als Satellite',
    'satellite.create': 'Satellite erstellen',
    'satellite.name': 'Name',
    'satellite.origin_strategy': 'Quell-Strategy',
    'satellite.select_strategy': 'Strategy wählen...',
    'satellite.mode': 'Modus',
    'satellite.monetization': 'Monetarisierung',
    'satellite.bio_link': 'Bio Link URL',
    'satellite.target_followers': 'Follower-Ziel',
    'satellite.revenue_target': 'Umsatz-Ziel',
    'satellite.link_account': 'Account verknüpfen',
    'satellite.promote_to_crm': '→ CRM',
    'satellite.leads_count': 'Leads',
    'satellite.revenue': 'Umsatz',
    'satellite.no_satellites': 'Noch keine Satellites',
    'satellite.select_satellite': 'Satellite auswählen',
    'satellite.settings': 'Einstellungen',
    'satellite.no_leads': 'Noch keine Leads',
    'satellite.add_lead': 'Lead hinzufügen',
    'sse.connection_lost': 'Live-Updates unterbrochen. Daten könnten veraltet sein.',
    'sse.reconnect': 'Neu verbinden',
    'ig.link_failed_warning': 'Instagram verbunden, aber Auto-Verknüpfung fehlgeschlagen. Bitte manuell verknüpfen.',
    'ig.disconnect_fetch_error': 'Betroffene Kanäle konnten nicht überprüft werden.',
    'ig.no_ig_channels': 'Keine Instagram-Kanäle vorhanden',
    'ig.select_channel_first': 'Erst einen Kanal auswählen',
    'ig.link_broken': 'Link defekt',
    'ig.no_connection_linked': 'Kein IG-Account mit diesem Kanal verknüpft',
    'ig.connected_success_channel': 'Instagram erfolgreich verbunden und verknüpft!',
    // Content Strategy Module
    'strategy.module.content': 'Content-Strategie',
    'strategy.module.vision': 'Vision & Mission',
    'strategy.module.principles': 'Prinzipien & Werte',
    'strategy.module.goals': 'Strategische Ziele',
    'strategy.module.methods': 'Methoden',
    'strategy.module.evolution': 'Evolution Log',
    'strategy.foundation.title': 'Foundation',
    'strategy.foundation.create': 'Foundation einrichten',
    'strategy.foundation.singleton_warning': 'Es existiert bereits eine Foundation-Strategie.',
    'strategy.field.vision.vision_statement': 'Vision',
    'strategy.field.vision.mission_statement': 'Mission',
    'strategy.field.vision.target_horizon': 'Zeithorizont',
    'strategy.field.vision.north_star_metric': 'North Star Metric',
    'strategy.field.vision.non_goals': 'Non-Goals',
    'strategy.field.principles.core_principles': 'Leitprinzipien',
    'strategy.field.principles.decision_filters': 'Entscheidungsfilter',
    'strategy.field.principles.anti_patterns': 'Anti-Patterns',
    'strategy.field.goals.current_quarter': 'Aktuelles Quartal',
    'strategy.field.goals.objectives': 'Objectives & Key Results',
    'strategy.field.goals.last_review_date': 'Letztes Review',
    'strategy.field.goals.next_review_date': 'Nächstes Review',
    'strategy.field.methods.active_methods': 'Aktive Methoden',
    'strategy.field.methods.experimental_methods': 'In Erprobung',
    'strategy.field.methods.deprecated_methods': 'Verworfen',
    'strategy.field.evolution.entries': 'Einträge',
    'strategy.content.platform_label': 'Plattform',
    'strategy.content.interview_header': 'Content-Realitaet',
    'strategy.content.business_stage': 'In welcher Phase ist dein Business?',
    'strategy.content.existing_results': 'Welche Ergebnisse hast du schon?',
    'strategy.content.content_creator': 'Wer erstellt den Content?',
    'strategy.content.available_formats': 'Welche Formate kannst du produzieren?',
    'strategy.content.posting_capacity': 'Wie oft kannst du posten?',
    'strategy.content.account_identity': 'Account-Typ',
    'strategy.content.differentiator': 'Was macht deinen Content anders?',
    'strategy.content.existing_audience': 'Hast du schon Reichweite woanders?',
    'strategy.content.warm_leads': 'Direkter Zugang zu potenziellen Kunden?',
    'strategy.content.revenue_model': 'Wie verdienst du Geld?',
    'strategy.content.monetization_timeline': 'Wann soll Content zu Umsatz fuehren?',
    'strategy.content.strategy_header': 'Content-Strategie',
    'strategy.content.narrative_arc': 'Narrative (welche Geschichte baust du auf?)',
    'strategy.content.content_goal': 'Content-Ziel',
    'strategy.content.pillars': 'Content-Saeulen',
    'strategy.content.phases': 'Phasen',
    'strategy.content.active_phase': 'Aktive Phase',
    'strategy.content.phase_transition': 'Phase {current} war fuer {planned} Wochen geplant -- du bist bei {elapsed} Wochen. Bereit fuer {next}?',
    'strategy.content.bootstrap_btn': 'Bootstrap aus Nische',
    'strategy.content.generate_btn': 'Strategie generieren',
    'strategy.content.regenerate_btn': 'Strategie neu generieren',
    'strategy.content.required_fields_hint': 'Pflichtfelder fuer Strategie-Generierung',
    'strategy.content.add_pillar': 'Pillar hinzufuegen',
    'strategy.content.add_phase': 'Phase hinzufuegen',
    'strategy.content.activate_phase': 'Phase aktivieren',
    'strategy.content.pillar_weights_sum': 'Summe',
    'strategy.content.phase_transition_banner': 'Phase abgeschlossen?',
    'strategy.content.advance_phase': 'Naechste Phase starten',
  },
  en: {
    'nav.master_control': 'Master Control',
    'nav.ig_parasite': 'IG Parasite',
    'nav.profile_creator': 'Profile Creator',
    'nav.logout': 'Logout',
    'login.title': 'Agency OS',
    'login.username': 'Username',
    'login.password': 'Password',
    'login.submit': 'Sign In',
    'login.error': 'Invalid credentials',
    'stats.total_audience': 'Total Audience',
    'stats.total_accounts': 'Accounts',
    'stats.active_niches': 'Active Niches',
    'stats.avg_growth': 'Avg Growth',
    'stats.pending_review': 'Pending Reviews',
    'stats.stale_accounts': 'Stale Accounts',
    'stats.posts_scraped': 'Posts Scraped',
    'stats.rewrites': 'Rewrites',
    'tab.dashboard': 'Dashboard',
    'tab.review': 'Review Bank',
    'tab.pipeline': 'Pipeline',
    'tab.accounts': 'Accounts',
    'tab.setup': 'Profile Setup',
    'tab.feedback': 'Feedback Loop',
    'tab.settings': 'Account Settings',
    'accounts.add': 'Add Account',
    'accounts.search': 'Search...',
    'accounts.username': 'Username',
    'accounts.followers': 'Followers',
    'accounts.growth': 'Growth',
    'accounts.niche': 'Niche',
    'accounts.type': 'Type',
    'accounts.actions': 'Actions',
    'review.accept': 'Accept',
    'review.hide': 'Hide',
    'review.skip': 'Skip',
    'review.set_growth': 'Set Growth',
    'review.set_niche': 'Set Niche',
    'review.set_type': 'Set Type',
    'review.empty': 'No accounts to review',
    'pipeline.scrape': 'Scrape',
    'pipeline.ocr': 'Run OCR',
    'pipeline.rewrite': 'Rewrite',
    'pipeline.assign': 'Assign',
    'pipeline.scraped': 'Scraped',
    'pipeline.ready': 'Ready',
    'pipeline.assigned': 'Assigned',
    'pipeline.done': 'Done',
    'pipeline.select_niche': 'Select Niche',
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.close': 'Done',
    'common.saving': 'Saving...',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.delete': 'Delete',
    'toast.scrape_started': 'Scraping started...',
    'toast.scrape_done': 'Posts scraped',
    'toast.ocr_started': 'Extracting image text...',
    'toast.ocr_done': 'Image text extracted',
    'toast.rewrite_done': 'Caption rewritten',
    'toast.assigned': 'Assigned',
    'toast.error': 'Error occurred',
    'profile.name': 'Profile Name',
    'profile.wizard_username': 'Username & Branding',
    'profile.wizard_seo': 'SEO & Logo',
    'profile.wizard_bio': 'Bio & Description',
    'profile.wizard_launch': 'Launch Check',
    'profile.ai_sparring': 'AI Sparring',
    'nav.strategy_os': 'Strategy OS',
    'nav.activity_log': 'Activity Log',
    'nav.user_management': 'User Management',
    'common.yes': 'Yes',
    'common.no': 'No',
    'stats.own_followers': 'Total Followers',
    'stats.engagement_rate': 'Engagement Rate',
    'stats.published_week': 'Posts This Week',
    'master.my_accounts': 'My Accounts',
    'master.benchmark': 'Benchmark Accounts',
    'accounts.own_toggle': 'Own Account',
    'accounts.bulk_selected': 'selected',
    'accounts.bulk_action': 'Choose action',
    'accounts.bulk_mark_own': 'Mark as own account',
    'accounts.bulk_unmark_own': 'Remove own account',
    'accounts.bulk_change_niche': 'Change niche',
    'accounts.bulk_change_tier': 'Change tier',
    'accounts.bulk_hide': 'Hide',
    'strategy.strategies': 'Strategies',
    'strategy.new_strategy': 'New Strategy',
    'strategy.strategy_name': 'Strategy Name',
    'strategy.no_strategies': 'No strategies',
    'strategy.create_first': 'Create your first strategy in the sidebar',
    'strategy.select_strategy': 'Select a strategy',
    'strategy.confirm_delete': 'Delete this strategy?',
    'strategy.tab.workspace': 'Workspace',
    'strategy.tab.accounts': 'Accounts',
    'strategy.tab.kits': 'Profile Kits',
    'strategy.tab.documents': 'Documents',
    'strategy.tab.library': 'Library',
    'strategy.tab.dashboard': 'Dashboard',
    'strategy.docs.upload': 'Upload',
    'strategy.docs.drop_zone': 'Drop files here or click',
    'strategy.docs.max_size': 'Max 50 MB per file',
    'strategy.docs.accepted_types': 'PDF, DOCX, XLSX, PPTX, PNG, JPG, TXT',
    'strategy.docs.extracting': 'Extracting...',
    'strategy.docs.done': 'Done',
    'strategy.docs.error': 'Error',
    'strategy.docs.reprocess': 'Reprocess',
    'strategy.docs.delete': 'Delete',
    'strategy.docs.download': 'Download',
    'strategy.docs.preview': 'Preview',
    'strategy.docs.no_text': 'No text extracted',
    'strategy.docs.picker_title': 'Select Documents',
    'strategy.docs.select_all': 'Select all',
    'strategy.docs.select_none': 'Select none',
    'strategy.docs.confirm': 'Confirm',
    'strategy.docs.n_docs': '{{count}} Docs',
    'strategy.docs.include_docs': 'Include documents',
    'strategy.docs.selected_count': '{{selected}}/{{total}} selected',
    'strategy.docs.no_docs': 'No documents uploaded',
    'strategy.module.niche': '1. Niche',
    'strategy.module.market': '2. Market',
    'strategy.module.avatar': '3. Avatar',
    'strategy.module.archetype': '4. Archetype',
    'strategy.module.mvo': '5. MVO',
    'strategy.module.offer': '6. Offer',
    'strategy.module.message': '7. Message',
    'strategy.reality_check': 'Reality Check',
    'strategy.autofill': 'Autofill',
    'strategy.iterate': 'Iterate',
    'strategy.history': 'History',
    'strategy.load_more': 'Load more',
    'strategy.snapshot_banner': 'Snapshot from',
    'strategy.field_empty': 'Field is empty',
    'strategy.sonnet_hint': 'Tip: Shift+click for deeper analysis (Sonnet)',
    'strategy.no_history': 'No reality checks performed yet',
    'strategy.version_history': 'Version History',
    'strategy.no_versions': 'No saved versions',
    'strategy.restore': 'Restore',
    'strategy.outdated_warning': 'Upstream module changed · check if this module is still valid.',
    'strategy.upstream_hint': 'Based on',
    'strategy.unsaved': 'Unsaved',
    'strategy.export.title': 'Export the whole strategy as Markdown',
    'strategy.export.copy': 'Copy',
    'strategy.export.copied': 'Copied',
    'strategy.export.download': 'Download .md',
    'strategy.export.preamble': '# Instagram Content Strategy: {name}\nNiche: {niche} · Language: {lang}\n\nYou are my strategy advisor. Below is the full marketing and content strategy for this Instagram account (all modules from the "Strategy OS"). Use it as context for my next questions.\n\nIMPORTANT for re-import: keep the module markers in square brackets (e.g. [niche]) and the field keys in backticks (e.g. `niche_name`) exactly as-is, they are required to import the strategy back. You may freely edit the values.',
    'strategy.import.button': 'Import',
    'strategy.import.title': 'Import strategy',
    'strategy.import.paste_placeholder': 'Paste the exported (and Claude-edited) strategy text here…',
    'strategy.import.preview': 'Preview',
    'strategy.import.apply': 'Apply',
    'strategy.import.cancel': 'Cancel',
    'strategy.import.back': 'Back',
    'strategy.import.changes_count': '{modules} modules · {fields} field changes',
    'strategy.import.no_changes': 'No changes detected. Check that the [module] and `field` markers are still present.',
    'strategy.import.unknown_keys': 'Ignored (unknown markers): {keys}',
    'strategy.import.parse_error': 'Could not read the text. Does it still contain the [module] and `field` markers from the export?',
    'strategy.import.success': 'Import applied, the previous state is in the history.',
    'strategy.import.applying': 'Applying…',
    'strategy.import.old': 'old',
    'strategy.import.new': 'new',
    'strategy.name': 'Name',
    'strategy.status': 'Status',
    'strategy.generation': 'Gen.',
    'strategy.accounts': 'Accounts',
    'strategy.avg_er': 'Avg ER',
    'strategy.avg_growth': 'Avg Growth',
    'strategy.composite': 'Score',
    'strategy.composite_score': 'Composite Score',
    'strategy.no_data': 'No data',
    'strategy.strategy': 'Strategy',
    'strategy.leaderboard': 'Leaderboard',
    'strategy.merge_evolve': 'Merge & Evolve',
    'strategy.evolve': 'Evolve',
    'strategy.merge_desc': 'Select 2-5 strategies to merge. AI extracts the strongest elements.',
    'strategy.min_2_strategies': 'Select at least 2 strategies',
    'strategy.evolve_error': 'Evolution failed',
    'strategy.selected': 'selected',
    'strategy.performance_over_time': 'Performance Over Time',
    'strategy.content_heatmap': 'Content Type Heatmap',
    'strategy.no_chart_data': 'No performance data yet',
    'strategy.no_heatmap_data': 'No heatmap data yet',
    'strategy.signal': 'Signal',
    'strategy.noise': 'Noise',
    'strategy.signal_placeholder': 'What works',
    'strategy.noise_placeholder': 'What doesn\'t',
    'strategy.profile_kits': 'Profile Kits',
    'strategy.kits_desc': '10 unique IG profile concepts based on this strategy',
    'strategy.generate_kits': 'Generate Kits',
    'strategy.no_kits': 'No kits yet. Click "Generate Kits".',
    'strategy.kit.usernames': 'Username Variants',
    'strategy.kit.bio': 'Bio',
    'strategy.kit.pic_prompt': 'Profile Pic Prompt',
    'strategy.kit.link_strategy': 'Link-in-Bio Strategy',
    'strategy.kit.highlights': 'Highlight Themes',
    'strategy.kit.pillars': 'Content Pillars',
    'strategy.kit.frequency': 'Posting Frequency',
    'strategy.generate_kit': 'Generate Kit',
    'strategy.regenerate_kit': 'Regenerate',
    'strategy.refine_kit': 'Refine',
    'strategy.kit.personal': 'Personal Brand',
    'strategy.kit.theme': 'Theme Page',
    'strategy.kit.mixed': 'Mixed',
    'strategy.kit.personality_traits': 'Personality Traits',
    'strategy.kit.origin_story_hook': 'Origin Story Hook',
    'strategy.kit.face_style_prompt': 'Face Style Prompt',
    'strategy.kit.color_palette': 'Color Palette',
    'strategy.kit.brand_aesthetic': 'Brand Aesthetic',
    'strategy.kit.series_names': 'Content Series',
    'strategy.kit.starred': 'Starred',
    'strategy.kit.preset': 'Preset',
    'strategy.kit.custom_rules': 'Custom Rules',
    'strategy.kit.preview_prompt': 'Preview Prompt',
    'strategy.kit.refine_feedback_placeholder': 'Enter feedback... e.g. "more minimalist"',
    'strategy.kit.generation_history': 'Generation History',
    'strategy.kit.today_count': 'today',
    'strategy.kit.total_count': 'total',
    'strategy.kit.presets_title': 'Manage Presets',
    'strategy.kit.add_preset': 'Add Preset',
    'strategy.kit.undo_toast': 'Undo',
    'strategy.kit.model_haiku': 'Haiku (fast)',
    'strategy.kit.model_sonnet': 'Sonnet (deep)',
    'strategy.kit.seo_name': 'SEO Name',
    'strategy.kit.include_pfp': 'Include profile pic prompt',
    'strategy.kit.refine_field': 'Refine',
    'strategy.kit.field_feedback_placeholder': 'How should this be improved?',
    'strategy.kit.apply_learned': 'Apply learned preferences',
    'strategy.kit.mode_new': 'New Profile',
    'strategy.kit.mode_improve': 'Improve Profile',
    'strategy.platform_assets': 'Platform Assets',
    'strategy.logo_creator': 'Logo Creator',
    'strategy.highlight_covers': 'Highlight Covers',
    'strategy.assign': 'Assign',
    'strategy.unassign': 'Remove',
    'strategy.assign_account_placeholder': 'Enter username...',
    'strategy.assigned_at': 'Assigned',
    'strategy.no_accounts': 'No accounts assigned yet',
    'strategy.swap_account': 'Swap Account',
    'strategy.swap_confirm': 'Replace @{old} with @{new}?',
    'strategy.current_account': 'Current Account',
    'strategy.autofill_sequential': 'Sequential Review',
    'strategy.autofill_improve': 'Improve',
    'strategy.autofill_regenerate': 'Regenerate',
    'strategy.autofill_accept_next': 'Accept & Next',
    'strategy.autofill_step': 'Step',
    'strategy.all_categories': 'All Categories',
    'strategy.category': 'Category',
    'strategy.suggest_category': 'Suggest Category',
    'strategy.prompt_preview': 'Prompt Preview',
    'strategy.language': 'Language',
    'strategy.field.niche.niche_name': 'Niche Name',
    'strategy.field.niche.account_stage': 'Account Stage',
    'strategy.field.niche.profile_type': 'Profile type (company page / personal profile)',
    'strategy.field.niche.launch_proof_artifact': 'Launch proof (real number / attribution for the proof post)',
    'strategy.field.niche.management_type': 'Management Type',
    'strategy.field.niche.available_assets': 'Available Assets',
    'strategy.field.avatar.audience_gender': 'Audience Gender',
    'strategy.field.avatar.audience_age_range': 'Audience Age Range',
    'strategy.feedback': 'Feedback',
    'strategy.add_note': 'Note',
    'strategy.note_placeholder': 'Enter note...',
    'strategy.feedback_history': 'Feedback History',
    'strategy.no_feedback': 'No feedback yet',
    // Content Studio
    'content_studio.tab': 'Content Studio',
    'content_studio.select_strategy': 'Select Strategy (required)',
    'content_studio.no_strategy': 'Select a strategy to get started',
    'content_studio.tab.create': 'Create',
    'content_studio.tab.history': 'History',
    'content_studio.tab.analytics': 'Analytics',
    'content_studio.tab.plan': 'Plan',
    'content_studio.tab.batch': 'Batch',
    'content_studio.tab.queue': 'Scheduled',
    // Content Plan
    'plan.create_plan': 'Create Plan',
    'plan.plan_name': 'Plan Name',
    'plan.cycle_type': 'Cycle Type',
    'plan.cycle.weekly': 'Weekly',
    'plan.cycle.biweekly': 'Biweekly',
    'plan.cycle.monthly': 'Monthly',
    'plan.create': 'Create Plan',
    'plan.since': 'since',
    'plan.slots': 'slots',
    'plan.no_slots': 'No slots',
    'plan.add_slot': 'Add Slot',
    'plan.select_format': 'Select Format',
    'plan.auto_adjusted': 'Auto-adjusted',
    'plan.revert': 'Revert',
    'plan.locked_until': 'Locked until',
    'plan.today_schedule': "Today's Schedule",
    'plan.use_slot': 'Use',
    'plan.day.monday': 'Monday',
    'plan.day.tuesday': 'Tuesday',
    'plan.day.wednesday': 'Wednesday',
    'plan.day.thursday': 'Thursday',
    'plan.day.friday': 'Friday',
    'plan.day.saturday': 'Saturday',
    'plan.day.sunday': 'Sunday',
    'plan.time.morning': 'Morning',
    'plan.time.afternoon': 'Afternoon',
    'plan.time.evening': 'Evening',
    // Format Performance
    'performance.section_title': 'Format Performance',
    'performance.title': 'Performance by Format',
    'performance.refresh': 'Refresh',
    'performance.no_data': 'No data yet',
    'performance.posts': 'posts',
    'performance.avg_likes': 'Avg Likes',
    'performance.avg_comments': 'Avg Cmt.',
    'performance.er': 'ER',
    'performance.confidence': 'Confidence',
    'performance.suggestion_replace': 'Suggestion: Replace',
    'performance.ai_analysis': 'AI Analysis',
    'performance.auto_adjust': 'Auto-Adjust',
    'performance.ai_insights': 'AI Insights',
    'performance.top_format': 'Top Format',
    'performance.adjust_done': 'Auto-adjustments',
    'content_studio.content_type': 'Content Type',
    'content_studio.type.hook': 'Hook',
    'content_studio.type.caption': 'Caption',
    'content_studio.type.full_post': 'Full Post',
    'content_studio.type.video_drehplan': 'Video Script',
    'content_studio.type.carousel_concept': 'Carousel Concept',
    'content_studio.type.reel': 'Reel',
    'content_studio.type.stat_post': 'Statistics',
    'content_studio.type.split_post': 'Split',
    'content_studio.type.checklist_post': 'Checklist',
    'content_studio.type.cta': 'CTA',
    'content_studio.format.image': 'Image',
    'content_studio.format.video': 'Video',
    'content_studio.context_sources': 'Context Sources',
    'content_studio.use_strategy_context': 'Strategy Context',
    'content_studio.use_niche_directive': 'Niche Directive',
    'content_studio.use_competitor_posts': 'Competitor Posts',
    'content_studio.competitor_posts_label': 'Competitor Reference',
    'content_studio.style_preset': 'Style Preset',
    'content_studio.no_preset': 'No Preset',
    'content_studio.custom_rules': 'Custom Rules',
    'content_studio.custom_rules_placeholder': 'e.g. "Max 100 words, in English"',
    'content_studio.model_haiku': 'Haiku (fast)',
    'content_studio.model_sonnet': 'Sonnet (deep)',
    'content_studio.preview_prompt': 'Preview Prompt',
    'content_studio.generate': 'Generate',
    'content_studio.generating': 'Generating...',
    'content_studio.refine': 'Refine',
    'content_studio.refining': 'Refining...',
    'content_studio.regenerate': 'Regenerate',
    'content_studio.copy': 'Copy',
    'content_studio.copied': 'Copied!',
    'content_studio.star': 'Star',
    'content_studio.open_in_live': 'Open in Live tab',
    'content_studio.open_in_reel_builder': 'Open in Reel Builder',
    'content_studio.mark_posted': 'Mark as Posted',
    'content_studio.rate_good': '👍 Good',
    'content_studio.rate_bad': '👎 Bad',
    'content_studio.rate_adjust': '🔧 Adjust',
    'content_studio.refine_placeholder': 'Enter feedback...',
    'content_studio.history_empty': 'No generations yet',
    'content_studio.filter_all': 'All Types',
    'content_studio.filter_starred': 'Starred only',
    'content_studio.posted_url': 'Instagram Post URL',
    'content_studio.scrape_intervals': 'Engagement Check',
    'content_studio.interval_24h': '24 Hours',
    'content_studio.interval_72h': '72 Hours',
    'content_studio.interval_7d': '7 Days',
    'content_studio.mark_posted_submit': 'Save as Posted',
    'content_studio.engagement.likes': 'Likes',
    'content_studio.engagement.comments': 'Comments',
    'content_studio.engagement.views': 'Views',
    'content_studio.engagement.er': 'Engagement Rate',
    'content_studio.engagement.pending': 'Not yet scraped',
    'content_studio.analytics.total': 'Total',
    'content_studio.analytics.good': 'Good',
    'content_studio.analytics.bad': 'Bad',
    'content_studio.analytics.adjust': 'Adjust',
    'content_studio.no_output': 'No output available',
    'content_studio.no_account_assigned': 'No account assigned',
    'content_studio.select_channel': 'Select Instagram channel',
    'content_studio.no_linked_account': 'Channel has no linked account',
    'content_studio.link_account': 'Link account',
    'content_studio.unlink_account': 'Unlink account',
    'content_studio.select_account_to_link': 'Select account to link',
    'content_studio.no_accounts_available': 'No accounts available',
    'content_studio.version': 'v',
    'content_studio.generate_image': 'Generate Image',
    'content_studio.select_template': 'Select Template',
    'content_studio.image_url_placeholder': 'Image URL (optional)',
    'content_studio.download_image': 'Download Image',
    'content_studio.generating_image': 'Generating image...',
    'content_studio.try_another': 'Try another',
    'content_studio.image_error': 'Image could not be generated.',
    'content_studio.error_details': 'Details',
    'content_studio.change_url': 'Change URL',
    'content_studio.change_template': 'Change Template',
    'content_studio.apply': 'Apply',
    'content_studio.image_mode_none': 'No image',
    'content_studio.image_mode_single': 'Single image',
    'content_studio.image_mode_dual': 'Dual image',
    'content_studio.image_left': 'Left image',
    'content_studio.image_right': 'Right image',
    'content_studio.ai_recommended': 'AI recommended',
    'content_studio.tab_stock': 'Stock',
    'content_studio.tab_ai': 'AI',
    'content_studio.tab_url': 'URL',
    'content_studio.load_more': 'Load more',
    'content_studio.ai_prompt_placeholder': 'FLUX Prompt...',
    'content_studio.ai_model_schnell': 'Schnell (~2s)',
    'content_studio.ai_model_dev': 'Dev (~20s, HD)',
    'content_studio.ai_generate': 'Generate',
    'content_studio.ai_use': 'Use',
    'content_studio.ai_estimated_fast': '~2 seconds...',
    'content_studio.ai_estimated_slow': '~20 seconds...',
    'content_studio.ai_gen_retry': 'Retry',
    'content_studio.ai_gen_open_dashboard': 'Open FAL Dashboard',
    'content_studio.carousel.template': 'Template',
    'content_studio.carousel.no_template': 'No Template',
    'content_studio.carousel.hook': 'Hook',
    'content_studio.carousel.cta': 'CTA',
    'content_studio.carousel.rewrite_slide': 'Rewrite',
    'content_studio.carousel.generate_image': 'Generate Image',
    'content_studio.carousel.insert_after': '+ Slide',
    'content_studio.carousel.caption_label': 'Caption',
    'content_studio.carousel.hashtags_label': 'Hashtags',
    'content_studio.carousel.save_caption': 'Save',
    'content_studio.carousel.rewrite_caption': 'Rewrite ↻',
    'content_studio.carousel.confirm_template_change': 'Changing template will delete all generated images. Continue?',
    'content_studio.carousel.stale_banner': 'Brand changed since last render. Re-render to update.',
    'content_studio.layout.split': 'Split',
    'content_studio.layout.overlay': 'Overlay',
    'content_studio.layout.card': 'Card',
    'content_studio.layout.minimal_gradient': 'Gradient',
    'content_studio.layout.vertical_split': 'Vertical',
    'content_studio.layout.sticky_note': 'Sticky Note',
    'content_studio.layout.checklist': 'Checklist',
    'content_studio.layout.logo': 'Logo',
    'content_studio.layout.default': 'Default',
    'content_studio.no_stock_results': 'No results found.',
    'content_studio.suggest_alternatives': 'Suggest alternatives',
    'content_studio.alt_loading': 'Loading alternatives...',
    'stock_search.results_from': 'Results from {source}',
    'stock_search.fallback_used': '{primary} unavailable, showing {fallback} results',
    'stock_search.not_configured': 'Stock photo API not configured',
    'stock_search.auth_failed': 'API key invalid',
    'stock_search.rate_limited': 'Rate limited, try again later',
    'stock_search.api_error': 'API error',
    'stock_search.network_error': 'Network error',
    'stock_search.enrichment_failed': 'Keyword enrichment failed',
    // Outreach
    'outreach.phase.kalt': 'Cold',
    'outreach.phase.interesse': 'Interest',
    'outreach.phase.vertiefung': 'Deepening',
    'outreach.phase.closing': 'Closing',
    'outreach.state.nicht_verbunden': 'Not connected',
    'outreach.state.angefragt': 'Request sent',
    'outreach.state.abgelehnt': 'Declined',
    'outreach.state.verbunden': 'Connected',
    'outreach.state.angeschrieben': 'Messaged',
    'outreach.state.geghosted': 'Ghosted',
    'outreach.state.geantwortet': 'Replied',
    'outreach.state.termin': 'Meeting',
    'outreach.substate.konkrete_frage': 'Specific question',
    'outreach.substate.legitimitaetstest': 'Legitimacy test',
    'outreach.substate.gegenfrage': 'Counter-question',
    'outreach.substate.persoenliche_oeffnung': 'Personal opening',
    'outreach.substate.einwand_preis': 'Objection: price',
    'outreach.substate.einwand_timing': 'Objection: timing',
    'outreach.substate.einwand_fit': 'Objection: fit',
    'outreach.substate.weiterleitung': 'Referral',
    'outreach.substate.absage': 'Rejection',
    'outreach.state.empty': 'No texts for this state yet.',
    'outreach.state.oldPhase': 'Old phase',
    'outreach.state.connectors': 'Connectors (fit any state)',
    'outreach.marker.label': 'Marker',
    'outreach.marker.eingehend': 'Inbound',
    'outreach.marker.nur_reagiert': 'Only reacted',
    'outreach.marker.kurz_angebunden': 'Curt',
    'outreach.marker.gelesen_ohne_antwort': 'Read, no reply',
    'outreach.marker.hint': 'Set marker — does not change the state',
    'outreach.marker.remove': 'Remove marker',
    'outreach.state.reset': 'Derive state again',
    'outreach.state.resetKeepsPhase': 'phase stays at {phase}',
    'outreach.stats.byState': 'By relationship state',
    'outreach.stats.sameTargets': 'same {n} targets as above',
    'outreach.review.title': 'How was the response?',
    'outreach.review.fire': 'Fire',
    'outreach.review.ok': 'Ok',
    'outreach.review.weak': 'Weak',
    'outreach.review.no_reply': 'No Reply',
    'outreach.review.their_response': 'What did they respond? (optional)',
    'outreach.review.saved': 'Review saved!',
    'outreach.review.not_sent': "Didn't actually send (undo)",
    'outreach.used_badge': '{count}\u00d7 this week',
    'outreach.platform.linkedin': 'LinkedIn',
    'outreach.platform.email': 'E-Mail',
    'outreach.platform.instagram': 'Instagram',
    'outreach.platform.andere': 'Other',
    'outreach.platform.add': 'Add platform',
    'outreach.style.casual': 'Casual',
    'outreach.style.professional': 'Professional',
    'outreach.style.direkt': 'Direct',
    'outreach.style.empathisch': 'Empathic',
    'outreach.enrichment.ig_profile': 'IG Profile',
    'outreach.enrichment.website': 'Website',
    'outreach.enrichment.competitors': 'Competitors',
    'outreach.enrichment.strategy': 'Strategy',
    'outreach.enrichment.upload_screenshot': 'Upload screenshot',
    'outreach.enrichment.analyze': 'Analyze',
    'outreach.enrichment.history': 'History',
    'outreach.enrichment.notes': 'Notes',
    'outreach.enrichment.auto_fetch': 'Auto-Fetch',
    'outreach.enrichment.manual': 'Manual',
    'outreach.enrichment.search_competitors': 'Search',
    'outreach.enrichment.linked': 'linked',
    'outreach.enrichment.analyzed': 'analyzed',
    'outreach.enrichment.competitors_found': '{count} competitors',
    'outreach.enrichment.loading': 'Analyzing...',
    'outreach.target.new': 'New Target',
    'outreach.target.company_name': 'Company Name',
    'outreach.target.ig_username': 'IG Username',
    'outreach.target.platforms': 'Platforms',
    'outreach.target.strategy': 'Strategy',
    'outreach.target.website': 'Website',
    // Sales CRM
    'nav.sales_crm': 'Sales CRM',
    'nav.outreach': 'Business Outreach',
    'sales.listbuilding': 'Listbuilding',
    'sales.tracking': 'Sales Tracking',
    'sales.add_lead': 'Add Lead',
    'sales.call': 'Call',
    'sales.start_call': 'Start Call',
    'sales.submit_call': 'Save Call',
    'sales.update_status_prompt': 'Update lead status?',
    'sales.follow_up_date': 'Follow-up Date',
    'sales.script_editor': 'Edit Script',
    'sales.kpi.total_calls': 'Total Calls',
    'sales.kpi.won': 'Won',
    'sales.kpi.lost': 'Lost',
    'sales.kpi.conversion': 'Conversion %',
    'sales.emotion.warm': 'Warm',
    'sales.emotion.neutral': 'Neutral',
    'sales.emotion.cold': 'Cold',
    'sales.emotion.hostile': 'Hostile',
    'sales.source.linkedin': 'LinkedIn',
    'sales.source.instagram': 'Instagram',
    'sales.source.referral': 'Referral',
    'sales.source.cold': 'Cold',
    'sales.source.website': 'Website',
    'sales.status.new': 'New',
    'sales.status.called': 'Called',
    'sales.status.follow_up': 'Follow-up',
    'sales.status.won': 'Won',
    'sales.status.lost': 'Lost',
    'sales.pre_call_summary': 'Pre-Call Summary',
    'sales.no_previous_calls': 'First Call',
    'sales.script_save': 'Save Script',
    'sales.version_history': 'Version History',
    'sales.restore_version': 'Restore',
    'strategy.field.niche.problemsAndDesires': 'Problems, fears, and desires per niche',
    'strategy.field.niche.mostPowerfulProblem': 'The single most powerful problem or desire',
    'strategy.field.niche.transformationBefore': 'Current state (before) · where are they now?',
    'strategy.field.niche.transformationAfter': 'Desired state (after) · where do they want to be?',
    'strategy.field.market.q1': 'What keeps them awake at night?',
    'strategy.field.market.q2': 'What are they afraid of?',
    'strategy.field.market.q3': 'What are they angry about? Who at?',
    'strategy.field.market.q4': 'Top 3 daily frustrations',
    'strategy.field.market.q5': 'What trends are occurring in their business/lives?',
    'strategy.field.market.q6': 'What do they secretly desire most?',
    'strategy.field.market.q7': 'Is there a built-in bias to how they make decisions?',
    'strategy.field.market.q8': 'Do they have their own language or jargon?',
    'strategy.field.market.q9': 'Who else sells something similar? How?',
    'strategy.field.market.q10': 'Who has tried selling similar and failed? How?',
    'strategy.field.avatar.name': 'Avatar name (e.g. "Aaron Avatar")',
    'strategy.field.avatar.occupation': 'Occupation or descriptive title',
    'strategy.field.avatar.location': 'Where do they live?',
    'strategy.field.avatar.age': 'How old are they?',
    'strategy.field.avatar.education': 'Level of education',
    'strategy.field.avatar.accomplishments': 'What have they accomplished?',
    'strategy.field.avatar.weeklyRoutine': 'How do they spend their week?',
    'strategy.field.avatar.outsideWork': 'What do they do outside of work?',
    'strategy.field.avatar.newsSources': 'Where do they get their news?',
    'strategy.field.avatar.income': 'How much do they make?',
    'strategy.field.avatar.jobFeelings': 'How do they feel about their job?',
    'strategy.field.avatar.lifeConcerns': 'What are their concerns in life?',
    'strategy.field.avatar.marketingPersonality': 'Personality aspects that affect marketing',
    'strategy.field.avatar.backstory': 'Past events leading to this point',
    'strategy.field.avatar.pastFeelings': 'How they feel about the past',
    'strategy.field.avatar.currentInterests': 'What they\'re currently interested in',
    'strategy.field.avatar.relationshipStatus': 'Married/divorced/single/children?',
    'strategy.field.avatar.familyImpact': 'How family affects product usage',
    'strategy.field.avatar.whyProductMatters': 'How does your product solve their need?',
    'strategy.field.avatar.purchaseTrigger': 'What is the "final straw" that makes them buy?',
    'strategy.field.archetype.failure_scene': 'What is the exact failure scene? (ONE concrete moment, present tense, max 2 sentences)',
    'strategy.field.archetype.identity_tension': 'What does the viewer believe about himself that contradicts his results?',
    'strategy.field.archetype.insight_gap': 'What is the viewer not willing to admit?',
    'strategy.field.archetype.winning_scene': 'What does "winning" look like as a concrete, visual scene?',
    'strategy.field.mvo.niche': 'What is the niche?',
    'strategy.field.mvo.currentSituation': 'Current situation',
    'strategy.field.mvo.desiredSituation': 'Desired situation',
    'strategy.field.mvo.costOfStaying': 'What is it costing them to stay?',
    'strategy.field.mvo.worthOfGetting': 'What would it be worth to get there?',
    'strategy.field.mvo.whatParticipantsDo': 'What are most participants doing? How well?',
    'strategy.field.mvo.whatProvidersDo': 'What are service providers offering? How well?',
    'strategy.field.mvo.whatCrushersDo': 'What are those crushing it doing? How different?',
    'strategy.field.offer.niche': 'What is the niche?',
    'strategy.field.offer.currentSituation': 'Current situation',
    'strategy.field.offer.desiredSituation': 'Desired situation',
    'strategy.field.offer.versionNumber': 'Version number',
    'strategy.field.offer.signalVsNoise': 'Signal vs Noise',
    'strategy.field.offer.minimumWork': 'Minimum work required for transformation',
    'strategy.field.offer.price': 'Fair but high-side price',
    'strategy.field.offer.certaintyOfNiche': 'How certain are you of this niche? (1-10)',
    'strategy.field.offer.painLevel': 'How painful is their current situation? (1-10)',
    'strategy.field.offer.urgencyLevel': 'How urgent is their desire? (1-10)',
    'strategy.field.offer.complexityLevel': 'How complex to offer the solution? (1=complex, 10=simple)',
    'strategy.field.offer.possibilityLevel': 'How possible to achieve desired situation? (1-10)',
    'strategy.field.offer.timeframeDays': 'Timeframe in days',
    'strategy.field.offer.separator': 'Part Two: Live Market Feedback',
    'strategy.field.offer.offersCount': 'Number of offers made (goal: 30+)',
    'strategy.field.offer.objections': 'What objections is the market giving?',
    'strategy.field.offer.thingsLiked': 'What is the market liking?',
    'strategy.field.offer.conversationConclusions': 'How are conversations ending?',
    'strategy.field.offer.emergingPatterns': 'What patterns keep recurring?',
    'strategy.field.offer.improvements': 'Ways to improve your hypothesis',
    'strategy.field.message.niche': 'What is the niche?',
    'strategy.field.message.currentSituation': 'Current situation',
    'strategy.field.message.desiredSituation': 'Desired situation',
    'strategy.field.message.versionNumber': 'Version number',
    'strategy.field.message.nicheLanguage': 'Their own language/slang, key words',
    'strategy.field.message.messageEquation': '"I help [niche] to [get result] by [your offer]"',
    'strategy.field.message.preResonanceScore': 'Resonance rating before feedback (1-10)',
    'strategy.field.message.separator': 'Part Two: Live Market Feedback',
    'strategy.field.message.offersCount': 'Number of offers made',
    'strategy.field.message.repeatedPhrases': 'Words/phrases prospects keep repeating',
    'strategy.field.message.recurringStories': 'Stories that recur across calls',
    'strategy.field.message.metaphorsUsed': 'Metaphors/analogies prospects use',
    'strategy.field.message.boredTopics': 'What bores or saddens them?',
    'strategy.field.message.excitedTopics': 'What excites or energises them?',
    'strategy.field.message.wordsNotResonated': 'Your words that did NOT resonate',
    'strategy.field.message.wordsResonated': 'Your words that DID resonate',
    'strategy.field.message.bestMetaphors': 'Your best metaphors/analogies',
    'strategy.field.message.postResonanceScore': 'Resonance rating after feedback (1-10)',
    'strategy.field.message.improvements': 'Ways to improve your message hypothesis',
    // Visual Identity module
    'strategy.module.visual': 'Visual Identity',
    'strategy.field.visual.visual_style': 'Visual Style',
    'strategy.field.visual.photo_style': 'Photo Style',
    'strategy.field.visual.preferred_templates': 'Preferred Templates',
    'strategy.field.visual.color_usage': 'Color Usage',
    'strategy.field.visual.image_mood': 'Image Mood',
    'strategy.field.visual.content_format_mix': 'Content Format Mix',
    'strategy.field.visual.photo_pool': 'Photo Pool',
    'strategy.field.visual.use_photos_for_carousel': 'Use Own Photos for Carousel Hook (Slide 1)',
    'strategy.field.visual.photo_pool_source': 'Photo Source',
    'strategy.field.visual.photo_pool_drive_folder_id': 'Google Drive Folder ID',
    'strategy.field.visual.photo_overlay_opacity': 'Overlay Opacity',
    'strategy.field.visual.logo_url': 'Logo',
    'strategy.field.visual.logo_shape': 'Logo Shape',
    'strategy.field.visual.logo_border_width': 'Logo Border Width',
    'strategy.field.visual.logo_border_color': 'Logo Border Color',
    'strategy.field.visual.logo_size': 'Logo Size',
    'strategy.field.visual.brand_identity': 'Brand Identity',
    'strategy.field.visual.brand_aesthetic': 'Brand Aesthetic',
    'strategy.field.visual.face_style_prompt': 'Face Style',
    'strategy.field.visual.profile_pic_prompt': 'Profile Photo Guide',
    'strategy.field.visual.color_palette': 'Brand Colors',
    'content_studio.logo_settings': 'Logo Settings',
    'content_studio.logo_size': 'Logo Size',
    'content_studio.border_width': 'Border Width',
    'content_studio.border_color': 'Border Color',
    // Audit
    'audit.tab': 'Audit',
    'audit.generate_tab': 'Generate',
    'audit.history_tab': 'History',
    'audit.upload_profile': 'Profile Screenshot',
    'audit.upload_feed': 'Feed Grid (optional)',
    'audit.drop_hint': 'Click, drag or Cmd+V',
    'audit.run_button': 'Audit Profile',
    'audit.overall_score': 'Overall Score',
    'audit.top_priorities': 'Top Priorities',
    'audit.status_green': 'Good',
    'audit.status_yellow': 'Improvable',
    'audit.status_red': 'Critical',
    'audit.status_concern': 'Strategy Conflict',
    'audit.apply': 'Apply',
    'audit.refine': 'Refine with AI',
    'audit.feed_analysis': 'Feed Analysis',
    'audit.no_audits': 'No audits yet',
    'audit.loading': 'Analysing...',
    'audit.current_profile': 'Current Profile',
    'audit.current_profile_empty': 'No profile data yet · run an audit or enter manually',
    'audit.current_profile_source': 'Source',
    'audit.action_to_kit': '→ To Kit',
    'audit.action_implemented': '✓ Implemented',
    'audit.action_dismiss': 'Dismiss',
    'audit.action_custom': 'Customize',
    'audit.implementation_score': '{done}/{total} implemented',
    'audit.custom_placeholder': 'Your version...',
    'audit.improve_disabled': 'Create a profile first via screenshot audit or add fields manually',
    'audit.seo_chars': '{n}/64 chars',
    'audit.seo_too_long': 'Max 64 chars!',
    'audit.save': 'Save',
    'audit.profile_screenshot': 'Profile Screenshot',
    'audit.feed_screenshot': 'Feed Grid (optional)',
    'audit.run': 'Audit Profile',
    'audit.field_results': 'Fields',
    'audit.show_history': 'Show History',
    'audit.no_history': 'No audits yet',
    'audit.platform_instagram': 'Instagram',
    'audit.platform_linkedin': 'LinkedIn',
    'audit.platform_landingpage': 'Landing Page',
    'audit.optimization': 'Optimization',
    'audit.strategy_fit': 'Strategy Fit',
    'audit.lp_url_label': 'Enter URL',
    'audit.lp_url_placeholder': 'https://your-site.com',
    'audit.lp_loading_screenshot': 'Generating screenshot...',
    'audit.lp_screenshot': 'Screenshot (required)',
    'audit.banner_upload': 'Banner (optional)',
    'audit.concern_warning': 'This change may conflict with your strategy. Apply anyway?',
    'audit.concern_confirm': 'Apply anyway',
    'audit.concern_cancel': 'Cancel',
    'audit.field_headline': 'Headline',
    'audit.field_about': 'About',
    'audit.field_featured': 'Featured',
    'audit.field_banner': 'Banner',
    'audit.field_subheadline': 'Subheadline',
    'audit.field_cta': 'Call to Action',
    'audit.field_social_proof': 'Social Proof',
    'audit.field_visual_identity': 'Visual Identity',
    'audit.field_conversion_structure': 'Conversion Structure',
    'audit.field_strategy_alignment': 'Strategy Alignment',
    'profile_overview.title': 'My Profile',
    'profile_overview.empty': 'No profile yet. Generate a kit and adopt fields.',
    'profile_overview.remove': 'Remove',
    'profile_overview.edit': 'Edit',
    'profile_overview.save': 'Save',
    'profile_overview.adopted': 'Adopted',
    'profile_overview.last_audit': 'Last Audit',
    'profile_overview.no_audit': 'No Audit',
    'profile_overview.add_field': 'Add Field',
    'profile_overview.select_field': 'Select field...',
    'profile_overview.cancel': 'Cancel',
    'settings.branding_title': 'Branding',
    'settings.app_name': 'App Name',
    'settings.logo': 'Logo',
    'settings.upload_logo': 'Upload Logo',
    'settings.primary_color': 'Primary Color',
    'settings.accent_color': 'Accent Color',
    'settings.save': 'Save',
    'settings.saved': 'Saved',
    'brand.profile': 'Profile',
    'brand.channels': 'Channels',
    'brand.competitors': 'Competitors',
    'brand.display_name': 'Brand Name',
    'brand.entity_type': 'Type',
    'brand.industry': 'Industry',
    'brand.website': 'Website',
    'brand.description': 'Description',
    'brand.entity_person': 'Person',
    'brand.entity_business': 'Business',
    'brand.entity_brand': 'Brand',
    'brand.add_channel': 'Add Channel',
    'brand.edit_channel': 'Edit Channel',
    'brand.set_primary': 'Set as Primary',
    'brand.remove_channel': 'Remove Channel',
    'brand.primary': 'Primary',
    'brand.platform_instagram': 'Instagram',
    'brand.platform_youtube': 'YouTube',
    'brand.platform_linkedin': 'LinkedIn',
    'brand.platform_tiktok': 'TikTok',
    'brand.platform_website': 'Website',
    'brand.platform_landing_page': 'Landing Page',
    'brand.add_competitor': 'Add Competitor',
    'brand.remove_competitor': 'Remove Competitor',
    'brand.scraping': 'Scraping...',
    'brand.scrape_apify': 'Scrape via Apify',
    'brand.check_account': 'Check Account',
    'brand.account_exists': 'already exists',
    'brand.account_not_found': 'not found',
    'brand.benchmark': 'Benchmark',
    'brand.benchmark_better': 'Better',
    'brand.benchmark_worse': 'Worse',
    'brand.create_new': 'Create New Brand',
    'brand.select_existing': 'Select Existing Brand',
    'brand.no_brand': 'No brand linked',
    'brand.no_channels': 'No channels yet',
    'nav.integrations': 'Integrations',
    'integrations.title': 'Integrations',
    'integrations.connected_accounts': 'Connected Accounts',
    'integrations.ig_connect': 'Connect Instagram',
    'integrations.ig_connect_other': 'Connect other account',
    'integrations.ig_disconnect': 'Disconnect',
    'integrations.ig_connected_success': 'Instagram connected successfully!',
    'integrations.ig_connect_error': 'Connection failed. Please try again.',
    'integrations.ig_no_connections': 'No Instagram accounts connected.',
    'integrations.ig_publish_history': 'Publish History',
    'integrations.ig_token_active': 'Active',
    'integrations.ig_token_expiring': 'Expiring Soon',
    'integrations.ig_token_expired': 'Expired',
    'content_studio.publish_ig': 'Post to IG',
    'content_studio.publish_ig_publishing': 'Publishing...',
    'content_studio.publish_ig_success': 'Published to Instagram!',
    'content_studio.publish_ig_failed': 'Publish failed',
    'content_studio.publish_ig_select_account': 'Select account',
    'content_studio.publish_ig_already_published': 'Already published',
    'content_studio.trending_audio_tip': 'Tip: carousels with a trending audio attached have a chance of appearing in the Reels tab (up to 10x reach). Audio must be selected manually inside Instagram.',
    'content_studio.trending_audio_link': 'Browse trending audio',
    // Satellite OS
    'nav.satellite_os': 'Satellite OS',
    // Content Vault
    'nav.vault': 'Content Vault',
    'nav.trending_music': 'Trending Music',
    'nav.reels': 'Reels',
    'nav.contact_pool': 'Contact Pool',
    'nav.group_content_engine': 'Content Engine',
    'nav.group_strategy': 'Strategy',
    'nav.group_sales_outreach': 'Sales & Outreach',
    'nav.group_system': 'System',
    'satellite.tab.dashboard': 'Dashboard',
    'satellite.tab.detail': 'Detail',
    'satellite.tab.leads': 'Lead Funnel',
    'satellite.status.setup': 'Setup',
    'satellite.status.growing': 'Growing',
    'satellite.status.monetizing': 'Monetizing',
    'satellite.status.sold': 'Sold',
    'satellite.status.archived': 'Archived',
    'satellite.fork_button': 'Fork as Satellite',
    'satellite.create': 'Create Satellite',
    'satellite.name': 'Name',
    'satellite.origin_strategy': 'Origin Strategy',
    'satellite.select_strategy': 'Select strategy...',
    'satellite.mode': 'Mode',
    'satellite.monetization': 'Monetization',
    'satellite.bio_link': 'Bio Link URL',
    'satellite.target_followers': 'Follower Target',
    'satellite.revenue_target': 'Revenue Target',
    'satellite.link_account': 'Link Account',
    'satellite.promote_to_crm': '→ CRM',
    'satellite.leads_count': 'Leads',
    'satellite.revenue': 'Revenue',
    'satellite.no_satellites': 'No satellites yet',
    'satellite.select_satellite': 'Select a satellite',
    'satellite.settings': 'Settings',
    'satellite.no_leads': 'No leads yet',
    'satellite.add_lead': 'Add Lead',
    'sse.connection_lost': 'Live updates paused. Data may be stale.',
    'sse.reconnect': 'Reconnect',
    'ig.link_failed_warning': 'Instagram connected, but auto-linking failed. Please link manually.',
    'ig.disconnect_fetch_error': 'Could not verify affected channels.',
    'ig.no_ig_channels': 'No Instagram channels available',
    'ig.select_channel_first': 'Select a channel first',
    'ig.link_broken': 'Link broken',
    'ig.no_connection_linked': 'No IG account linked to this channel',
    'ig.connected_success_channel': 'Instagram connected and linked!',
    // Content Strategy Module
    'strategy.module.content': 'Content Strategy',
    'strategy.module.vision': 'Vision & Mission',
    'strategy.module.principles': 'Principles & Values',
    'strategy.module.goals': 'Strategic Goals',
    'strategy.module.methods': 'Methods',
    'strategy.module.evolution': 'Evolution Log',
    'strategy.foundation.title': 'Foundation',
    'strategy.foundation.create': 'Set up Foundation',
    'strategy.foundation.singleton_warning': 'A Foundation strategy already exists.',
    'strategy.field.vision.vision_statement': 'Vision',
    'strategy.field.vision.mission_statement': 'Mission',
    'strategy.field.vision.target_horizon': 'Time Horizon',
    'strategy.field.vision.north_star_metric': 'North Star Metric',
    'strategy.field.vision.non_goals': 'Non-Goals',
    'strategy.field.principles.core_principles': 'Core Principles',
    'strategy.field.principles.decision_filters': 'Decision Filters',
    'strategy.field.principles.anti_patterns': 'Anti-Patterns',
    'strategy.field.goals.current_quarter': 'Current Quarter',
    'strategy.field.goals.objectives': 'Objectives & Key Results',
    'strategy.field.goals.last_review_date': 'Last Review',
    'strategy.field.goals.next_review_date': 'Next Review',
    'strategy.field.methods.active_methods': 'Active Methods',
    'strategy.field.methods.experimental_methods': 'Experimental',
    'strategy.field.methods.deprecated_methods': 'Deprecated',
    'strategy.field.evolution.entries': 'Entries',
    'strategy.content.platform_label': 'Platform',
    'strategy.content.interview_header': 'Content Reality',
    'strategy.content.business_stage': 'What stage is your business in?',
    'strategy.content.existing_results': 'What results do you already have?',
    'strategy.content.content_creator': 'Who creates the content?',
    'strategy.content.available_formats': 'Which formats can you produce?',
    'strategy.content.posting_capacity': 'How often can you post?',
    'strategy.content.account_identity': 'Account type',
    'strategy.content.differentiator': 'What makes your content different?',
    'strategy.content.existing_audience': 'Do you already have an audience elsewhere?',
    'strategy.content.warm_leads': 'Direct access to potential clients?',
    'strategy.content.revenue_model': 'How do you make money?',
    'strategy.content.monetization_timeline': 'When should content convert to revenue?',
    'strategy.content.strategy_header': 'Content Strategy',
    'strategy.content.narrative_arc': 'Narrative (what story are you building?)',
    'strategy.content.content_goal': 'Content Goal',
    'strategy.content.pillars': 'Content Pillars',
    'strategy.content.phases': 'Phases',
    'strategy.content.active_phase': 'Active Phase',
    'strategy.content.phase_transition': 'Phase {current} was planned for {planned} weeks - you\'re at {elapsed} weeks. Ready for {next}?',
    'strategy.content.bootstrap_btn': 'Bootstrap from Niche',
    'strategy.content.generate_btn': 'Generate Strategy',
    'strategy.content.regenerate_btn': 'Regenerate Strategy',
    'strategy.content.required_fields_hint': 'Required fields for strategy generation',
    'strategy.content.add_pillar': 'Add Pillar',
    'strategy.content.add_phase': 'Add Phase',
    'strategy.content.activate_phase': 'Activate Phase',
    'strategy.content.pillar_weights_sum': 'Sum',
    'strategy.content.phase_transition_banner': 'Phase complete?',
    'strategy.content.advance_phase': 'Start next phase',
  },
  es: {
    'nav.master_control': 'Control Maestro',
    'nav.ig_parasite': 'IG Parasite',
    'nav.profile_creator': 'Creador de Perfiles',
    'nav.logout': 'Cerrar sesión',
    'login.title': 'Agency OS',
    'login.username': 'Usuario',
    'login.password': 'Contraseña',
    'login.submit': 'Iniciar sesión',
    'login.error': 'Credenciales inválidas',
    'stats.total_audience': 'Audiencia Total',
    'stats.total_accounts': 'Cuentas',
    'stats.active_niches': 'Nichos Activos',
    'stats.avg_growth': 'Crecimiento Prom.',
    'stats.pending_review': 'Revisiones Pendientes',
    'stats.stale_accounts': 'Cuentas Obsoletas',
    'stats.posts_scraped': 'Posts Scrapeados',
    'stats.rewrites': 'Reescrituras',
    'tab.dashboard': 'Dashboard',
    'tab.review': 'Review Bank',
    'tab.pipeline': 'Pipeline',
    'tab.accounts': 'Cuentas',
    'tab.setup': 'Config. Perfil',
    'tab.feedback': 'Feedback Loop',
    'tab.settings': 'Config. Cuenta',
    'accounts.add': 'Agregar Cuenta',
    'accounts.search': 'Buscar...',
    'accounts.username': 'Usuario',
    'accounts.followers': 'Seguidores',
    'accounts.growth': 'Crecimiento',
    'accounts.niche': 'Nicho',
    'accounts.type': 'Tipo',
    'accounts.actions': 'Acciones',
    'review.accept': 'Aceptar',
    'review.hide': 'Ocultar',
    'review.skip': 'Saltar',
    'review.set_growth': 'Set Growth',
    'review.set_niche': 'Set Nicho',
    'review.set_type': 'Set Tipo',
    'review.empty': 'No hay cuentas por revisar',
    'pipeline.scrape': 'Scrapear',
    'pipeline.ocr': 'Ejecutar OCR',
    'pipeline.rewrite': 'Reescribir',
    'pipeline.assign': 'Asignar',
    'pipeline.scraped': 'Scrapeado',
    'pipeline.ready': 'Listo',
    'pipeline.assigned': 'Asignado',
    'pipeline.done': 'Hecho',
    'pipeline.select_niche': 'Seleccionar Nicho',
    'common.loading': 'Cargando...',
    'common.save': 'Guardar',
    'common.close': 'Hecho',
    'common.saving': 'Guardando...',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.delete': 'Eliminar',
    'toast.scrape_started': 'Scraping iniciado...',
    'toast.scrape_done': 'Posts scrapeados',
    'toast.ocr_started': 'Extrayendo texto de imagen...',
    'toast.ocr_done': 'Texto de imagen extraído',
    'toast.rewrite_done': 'Caption reescrito',
    'toast.assigned': 'Asignado',
    'toast.error': 'Error ocurrido',
    'profile.name': 'Nombre del Perfil',
    'profile.wizard_username': 'Usuario & Branding',
    'profile.wizard_seo': 'SEO & Logo',
    'profile.wizard_bio': 'Bio & Descripción',
    'profile.wizard_launch': 'Launch Check',
    'profile.ai_sparring': 'AI Sparring',
    'nav.strategy_os': 'Strategy OS',
    'nav.activity_log': 'Activity Log',
    'nav.user_management': 'Gestión de Usuarios',
    'common.yes': 'Sí',
    'common.no': 'No',
    'stats.own_followers': 'Seguidores Total',
    'stats.engagement_rate': 'Tasa de Engagement',
    'stats.published_week': 'Posts esta Semana',
    'master.my_accounts': 'Mis Cuentas',
    'master.benchmark': 'Cuentas Benchmark',
    'accounts.own_toggle': 'Cuenta Propia',
    'accounts.bulk_selected': 'seleccionados',
    'accounts.bulk_action': 'Elegir acción',
    'accounts.bulk_mark_own': 'Marcar como cuenta propia',
    'accounts.bulk_unmark_own': 'Quitar cuenta propia',
    'accounts.bulk_change_niche': 'Cambiar nicho',
    'accounts.bulk_change_tier': 'Cambiar tier',
    'accounts.bulk_hide': 'Ocultar',
    'strategy.strategies': 'Estrategias',
    'strategy.new_strategy': 'Nueva Estrategia',
    'strategy.strategy_name': 'Nombre',
    'strategy.no_strategies': 'Sin estrategias',
    'strategy.create_first': 'Crea tu primera estrategia en el panel',
    'strategy.select_strategy': 'Selecciona una estrategia',
    'strategy.confirm_delete': '¿Eliminar esta estrategia?',
    'strategy.tab.workspace': 'Workspace',
    'strategy.tab.accounts': 'Cuentas',
    'strategy.tab.kits': 'Kits de Perfil',
    'strategy.tab.documents': 'Documentos',
    'strategy.tab.library': 'Biblioteca',
    'strategy.tab.dashboard': 'Dashboard',
    'strategy.docs.upload': 'Subir',
    'strategy.docs.drop_zone': 'Suelta archivos aquí o haz clic',
    'strategy.docs.max_size': 'Máx. 50 MB por archivo',
    'strategy.docs.accepted_types': 'PDF, DOCX, XLSX, PPTX, PNG, JPG, TXT',
    'strategy.docs.extracting': 'Extrayendo...',
    'strategy.docs.done': 'Listo',
    'strategy.docs.error': 'Error',
    'strategy.docs.reprocess': 'Reprocesar',
    'strategy.docs.delete': 'Eliminar',
    'strategy.docs.download': 'Descargar',
    'strategy.docs.preview': 'Vista previa',
    'strategy.docs.no_text': 'Sin texto extraído',
    'strategy.docs.picker_title': 'Seleccionar documentos',
    'strategy.docs.select_all': 'Seleccionar todo',
    'strategy.docs.select_none': 'Deseleccionar todo',
    'strategy.docs.confirm': 'Confirmar',
    'strategy.docs.n_docs': '{{count}} Docs',
    'strategy.docs.include_docs': 'Incluir documentos',
    'strategy.docs.selected_count': '{{selected}}/{{total}} seleccionados',
    'strategy.docs.no_docs': 'Sin documentos subidos',
    'strategy.module.niche': '1. Nicho',
    'strategy.module.market': '2. Mercado',
    'strategy.module.avatar': '3. Avatar',
    'strategy.module.archetype': '4. Arquetipo',
    'strategy.module.mvo': '5. MVO',
    'strategy.module.offer': '6. Oferta',
    'strategy.module.message': '7. Mensaje',
    'strategy.reality_check': 'Reality Check',
    'strategy.autofill': 'Autocompletar',
    'strategy.iterate': 'Iterar',
    'strategy.history': 'Historial',
    'strategy.load_more': 'Cargar más',
    'strategy.snapshot_banner': 'Snapshot de',
    'strategy.field_empty': 'Campo vacío',
    'strategy.sonnet_hint': 'Consejo: Shift+clic para análisis profundo (Sonnet)',
    'strategy.no_history': 'No se han realizado reality checks aún',
    'strategy.version_history': 'Historial de Versiones',
    'strategy.no_versions': 'Sin versiones guardadas',
    'strategy.restore': 'Restaurar',
    'strategy.outdated_warning': 'El módulo upstream cambió · verifica si este módulo sigue vigente.',
    'strategy.upstream_hint': 'Basado en',
    'strategy.unsaved': 'Sin guardar',
    'strategy.export.title': 'Exportar toda la estrategia como Markdown',
    'strategy.export.copy': 'Copiar',
    'strategy.export.copied': 'Copiado',
    'strategy.export.download': 'Descargar .md',
    'strategy.export.preamble': '# Estrategia de contenido de Instagram: {name}\nNicho: {niche} · Idioma: {lang}\n\nEres mi asesor de estrategia. A continuación está la estrategia completa de marketing y contenido de esta cuenta de Instagram (todos los módulos del "Strategy OS"). Úsala como contexto para mis próximas preguntas.\n\nIMPORTANTE para reimportar: mantén los marcadores de módulo entre corchetes (p. ej. [niche]) y las claves de campo entre comillas invertidas (p. ej. `niche_name`) exactamente igual, son necesarios para volver a importar la estrategia. Puedes editar los valores libremente.',
    'strategy.import.button': 'Importar',
    'strategy.import.title': 'Importar estrategia',
    'strategy.import.paste_placeholder': 'Pega aquí el texto de la estrategia exportado (y editado en Claude)…',
    'strategy.import.preview': 'Vista previa',
    'strategy.import.apply': 'Aplicar',
    'strategy.import.cancel': 'Cancelar',
    'strategy.import.back': 'Atrás',
    'strategy.import.changes_count': '{modules} módulos · {fields} cambios de campo',
    'strategy.import.no_changes': 'No se detectaron cambios. Verifica que los marcadores [módulo] y `campo` sigan presentes.',
    'strategy.import.unknown_keys': 'Ignorados (marcadores desconocidos): {keys}',
    'strategy.import.parse_error': 'No se pudo leer el texto. ¿Aún contiene los marcadores [módulo] y `campo` de la exportación?',
    'strategy.import.success': 'Importación aplicada, el estado anterior está en el historial.',
    'strategy.import.applying': 'Aplicando…',
    'strategy.import.old': 'antes',
    'strategy.import.new': 'nuevo',
    'strategy.name': 'Nombre',
    'strategy.status': 'Estado',
    'strategy.generation': 'Gen.',
    'strategy.accounts': 'Cuentas',
    'strategy.avg_er': 'ER Prom.',
    'strategy.avg_growth': 'Crecimiento Prom.',
    'strategy.composite': 'Score',
    'strategy.composite_score': 'Score Compuesto',
    'strategy.no_data': 'Sin datos',
    'strategy.strategy': 'Estrategia',
    'strategy.leaderboard': 'Clasificación',
    'strategy.merge_evolve': 'Fusionar & Evolucionar',
    'strategy.evolve': 'Evolucionar',
    'strategy.merge_desc': 'Selecciona 2-5 estrategias. La IA extrae los mejores elementos.',
    'strategy.min_2_strategies': 'Selecciona al menos 2 estrategias',
    'strategy.evolve_error': 'Error en evolución',
    'strategy.selected': 'seleccionadas',
    'strategy.performance_over_time': 'Rendimiento en el Tiempo',
    'strategy.content_heatmap': 'Mapa de Calor de Contenido',
    'strategy.no_chart_data': 'Sin datos de rendimiento aún',
    'strategy.no_heatmap_data': 'Sin datos de mapa de calor aún',
    'strategy.signal': 'Señal',
    'strategy.noise': 'Ruido',
    'strategy.signal_placeholder': 'Lo que funciona',
    'strategy.noise_placeholder': 'Lo que no',
    'strategy.profile_kits': 'Kits de Perfil',
    'strategy.kits_desc': '10 conceptos únicos de perfil IG basados en esta estrategia',
    'strategy.generate_kits': 'Generar Kits',
    'strategy.no_kits': 'Sin kits aún. Haz clic en "Generar Kits".',
    'strategy.kit.usernames': 'Variantes de Usuario',
    'strategy.kit.bio': 'Bio',
    'strategy.kit.pic_prompt': 'Prompt de Foto de Perfil',
    'strategy.kit.link_strategy': 'Estrategia Link en Bio',
    'strategy.kit.highlights': 'Temas de Highlights',
    'strategy.kit.pillars': 'Pilares de Contenido',
    'strategy.kit.frequency': 'Frecuencia de Publicación',
    'strategy.generate_kit': 'Generar Kit',
    'strategy.regenerate_kit': 'Regenerar',
    'strategy.refine_kit': 'Refinar',
    'strategy.kit.personal': 'Marca Personal',
    'strategy.kit.theme': 'Página Temática',
    'strategy.kit.mixed': 'Mixto',
    'strategy.kit.personality_traits': 'Rasgos de Personalidad',
    'strategy.kit.origin_story_hook': 'Hook Historia de Origen',
    'strategy.kit.face_style_prompt': 'Prompt Estilo de Cara',
    'strategy.kit.color_palette': 'Paleta de Colores',
    'strategy.kit.brand_aesthetic': 'Estética de Marca',
    'strategy.kit.series_names': 'Series de Contenido',
    'strategy.kit.starred': 'Destacado',
    'strategy.kit.preset': 'Preset',
    'strategy.kit.custom_rules': 'Reglas Personalizadas',
    'strategy.kit.preview_prompt': 'Vista Previa del Prompt',
    'strategy.kit.refine_feedback_placeholder': 'Ingresa feedback... ej. "más minimalista"',
    'strategy.kit.generation_history': 'Historial de Generación',
    'strategy.kit.today_count': 'hoy',
    'strategy.kit.total_count': 'total',
    'strategy.kit.presets_title': 'Gestionar Presets',
    'strategy.kit.add_preset': 'Agregar Preset',
    'strategy.kit.undo_toast': 'Deshacer',
    'strategy.kit.model_haiku': 'Haiku (rápido)',
    'strategy.kit.model_sonnet': 'Sonnet (profundo)',
    'strategy.kit.seo_name': 'Nombre SEO',
    'strategy.kit.include_pfp': 'Incluir prompt de foto de perfil',
    'strategy.kit.refine_field': 'Refinar',
    'strategy.kit.field_feedback_placeholder': '¿Cómo debería mejorarse esto?',
    'strategy.kit.apply_learned': 'Aplicar preferencias aprendidas',
    'strategy.kit.mode_new': 'Perfil Nuevo',
    'strategy.kit.mode_improve': 'Mejorar Perfil',
    'strategy.assign': 'Asignar',
    'strategy.unassign': 'Quitar',
    'strategy.assign_account_placeholder': 'Ingresar usuario...',
    'strategy.assigned_at': 'Asignado',
    'strategy.no_accounts': 'Sin cuentas asignadas aún',
    'strategy.swap_account': 'Cambiar cuenta',
    'strategy.swap_confirm': '¿Reemplazar @{old} con @{new}?',
    'strategy.current_account': 'Cuenta actual',
    'strategy.autofill_sequential': 'Revisión secuencial',
    'strategy.autofill_improve': 'Mejorar',
    'strategy.autofill_regenerate': 'Regenerar',
    'strategy.autofill_accept_next': 'Aceptar y siguiente',
    'strategy.autofill_step': 'Paso',
    'strategy.all_categories': 'Todas las categorías',
    'strategy.category': 'Categoría',
    'strategy.suggest_category': 'Sugerir categoría',
    'strategy.prompt_preview': 'Vista previa del prompt',
    'strategy.language': 'Idioma',
    'strategy.field.niche.niche_name': 'Nombre de nicho',
    'strategy.field.niche.account_stage': 'Etapa de cuenta',
    'strategy.field.niche.profile_type': 'Tipo de perfil (página de empresa / perfil personal)',
    'strategy.field.niche.launch_proof_artifact': 'Prueba de lanzamiento (cifra real / atribución para el post de prueba)',
    'strategy.field.niche.management_type': 'Tipo de gestión',
    'strategy.field.niche.available_assets': 'Activos disponibles',
    'strategy.field.avatar.audience_gender': 'Género del público',
    'strategy.field.avatar.audience_age_range': 'Edad del público',
    'strategy.feedback': 'Feedback',
    'strategy.add_note': 'Nota',
    'strategy.note_placeholder': 'Ingresar nota...',
    'strategy.feedback_history': 'Historial de Feedback',
    'strategy.no_feedback': 'Sin feedback aún',
    // Content Studio
    'content_studio.tab': 'Content Studio',
    'content_studio.select_strategy': 'Seleccionar Strategy (obligatorio)',
    'content_studio.no_strategy': 'Selecciona una strategy para comenzar',
    'content_studio.tab.create': 'Crear',
    'content_studio.tab.history': 'Historial',
    'content_studio.tab.analytics': 'Analytics',
    'content_studio.tab.plan': 'Plan',
    'content_studio.tab.batch': 'Batch',
    'content_studio.tab.queue': 'Programado',
    // Content Plan
    'plan.create_plan': 'Crear Plan',
    'plan.plan_name': 'Nombre del Plan',
    'plan.cycle_type': 'Tipo de Ciclo',
    'plan.cycle.weekly': 'Semanal',
    'plan.cycle.biweekly': 'Quincenal',
    'plan.cycle.monthly': 'Mensual',
    'plan.create': 'Crear Plan',
    'plan.since': 'desde',
    'plan.slots': 'slots',
    'plan.no_slots': 'Sin slots',
    'plan.add_slot': 'Agregar Slot',
    'plan.select_format': 'Seleccionar Formato',
    'plan.auto_adjusted': 'Auto-ajustado',
    'plan.revert': 'Revertir',
    'plan.locked_until': 'Bloqueado hasta',
    'plan.today_schedule': 'Horario de Hoy',
    'plan.use_slot': 'Usar',
    'plan.day.monday': 'Lunes',
    'plan.day.tuesday': 'Martes',
    'plan.day.wednesday': 'Miércoles',
    'plan.day.thursday': 'Jueves',
    'plan.day.friday': 'Viernes',
    'plan.day.saturday': 'Sábado',
    'plan.day.sunday': 'Domingo',
    'plan.time.morning': 'Mañana',
    'plan.time.afternoon': 'Tarde',
    'plan.time.evening': 'Noche',
    // Format Performance
    'performance.section_title': 'Rendimiento por Formato',
    'performance.title': 'Rendimiento por Formato',
    'performance.refresh': 'Actualizar',
    'performance.no_data': 'Sin datos aún',
    'performance.posts': 'posts',
    'performance.avg_likes': 'Prom. Likes',
    'performance.avg_comments': 'Prom. Cmt.',
    'performance.er': 'ER',
    'performance.confidence': 'Confianza',
    'performance.suggestion_replace': 'Sugerencia: Reemplazar',
    'performance.ai_analysis': 'Análisis IA',
    'performance.auto_adjust': 'Auto-Ajustar',
    'performance.ai_insights': 'Perspectivas IA',
    'performance.top_format': 'Formato Top',
    'performance.adjust_done': 'Auto-ajustes',
    'content_studio.content_type': 'Tipo de Contenido',
    'content_studio.type.hook': 'Hook',
    'content_studio.type.caption': 'Caption',
    'content_studio.type.full_post': 'Post Completo',
    'content_studio.type.video_drehplan': 'Guión de Video',
    'content_studio.type.carousel_concept': 'Concepto Carrusel',
    'content_studio.type.reel': 'Reel',
    'content_studio.type.stat_post': 'Estadísticas',
    'content_studio.type.split_post': 'Split',
    'content_studio.type.checklist_post': 'Checklist',
    'content_studio.type.cta': 'CTA',
    'content_studio.format.image': 'Imagen',
    'content_studio.format.video': 'Video',
    'content_studio.context_sources': 'Fuentes de Contexto',
    'content_studio.use_strategy_context': 'Contexto de Strategy',
    'content_studio.use_niche_directive': 'Directiva de Nicho',
    'content_studio.use_competitor_posts': 'Posts de Competidores',
    'content_studio.competitor_posts_label': 'Referencia de Competidores',
    'content_studio.style_preset': 'Preset de Estilo',
    'content_studio.no_preset': 'Sin Preset',
    'content_studio.custom_rules': 'Reglas Personalizadas',
    'content_studio.custom_rules_placeholder': 'ej. "Máximo 100 palabras, en español"',
    'content_studio.model_haiku': 'Haiku (rápido)',
    'content_studio.model_sonnet': 'Sonnet (profundo)',
    'content_studio.preview_prompt': 'Vista previa del Prompt',
    'content_studio.generate': 'Generar',
    'content_studio.generating': 'Generando...',
    'content_studio.refine': 'Refinar',
    'content_studio.refining': 'Refinando...',
    'content_studio.regenerate': 'Regenerar',
    'content_studio.copy': 'Copiar',
    'content_studio.copied': '¡Copiado!',
    'content_studio.star': 'Destacar',
    'content_studio.open_in_live': 'Abrir en pestaña Live',
    'content_studio.open_in_reel_builder': 'Abrir en Reel Builder',
    'content_studio.mark_posted': 'Marcar como publicado',
    'content_studio.rate_good': '👍 Bueno',
    'content_studio.rate_bad': '👎 Malo',
    'content_studio.rate_adjust': '🔧 Ajustar',
    'content_studio.refine_placeholder': 'Ingresa feedback...',
    'content_studio.history_empty': 'Sin generaciones aún',
    'content_studio.filter_all': 'Todos los tipos',
    'content_studio.filter_starred': 'Solo destacados',
    'content_studio.posted_url': 'URL del Post de Instagram',
    'content_studio.scrape_intervals': 'Control de Engagement',
    'content_studio.interval_24h': '24 Horas',
    'content_studio.interval_72h': '72 Horas',
    'content_studio.interval_7d': '7 Días',
    'content_studio.mark_posted_submit': 'Guardar como publicado',
    'content_studio.engagement.likes': 'Likes',
    'content_studio.engagement.comments': 'Comentarios',
    'content_studio.engagement.views': 'Vistas',
    'content_studio.engagement.er': 'Tasa de Engagement',
    'content_studio.engagement.pending': 'Aún no scrapeado',
    'content_studio.analytics.total': 'Total',
    'content_studio.analytics.good': 'Bueno',
    'content_studio.analytics.bad': 'Malo',
    'content_studio.analytics.adjust': 'Ajustar',
    'content_studio.no_output': 'Sin output disponible',
    'content_studio.no_account_assigned': 'Sin cuenta asignada',
    'content_studio.select_channel': 'Seleccionar canal de Instagram',
    'content_studio.no_linked_account': 'El canal no tiene cuenta vinculada',
    'content_studio.link_account': 'Vincular cuenta',
    'content_studio.unlink_account': 'Desvincular cuenta',
    'content_studio.select_account_to_link': 'Seleccionar cuenta para vincular',
    'content_studio.no_accounts_available': 'No hay cuentas disponibles',
    'content_studio.version': 'v',
    'content_studio.generate_image': 'Generar Imagen',
    'content_studio.select_template': 'Seleccionar Template',
    'content_studio.image_url_placeholder': 'URL de imagen (opcional)',
    'content_studio.download_image': 'Descargar Imagen',
    'content_studio.generating_image': 'Generando imagen...',
    'content_studio.try_another': 'Otro template',
    'content_studio.image_error': 'No se pudo generar la imagen.',
    'content_studio.error_details': 'Detalles',
    'content_studio.change_url': 'Cambiar URL',
    'content_studio.change_template': 'Cambiar plantilla',
    'content_studio.apply': 'Aplicar',
    'content_studio.image_mode_none': 'Sin imagen',
    'content_studio.image_mode_single': 'Una imagen',
    'content_studio.image_mode_dual': 'Dos imágenes',
    'content_studio.image_left': 'Imagen izquierda',
    'content_studio.image_right': 'Imagen derecha',
    'content_studio.ai_recommended': 'Recomendado por AI',
    'content_studio.tab_stock': 'Stock',
    'content_studio.tab_ai': 'AI',
    'content_studio.tab_url': 'URL',
    'content_studio.load_more': 'Cargar más',
    'content_studio.ai_prompt_placeholder': 'FLUX Prompt...',
    'content_studio.ai_model_schnell': 'Schnell (~2s)',
    'content_studio.ai_model_dev': 'Dev (~20s, HD)',
    'content_studio.ai_generate': 'Generar',
    'content_studio.ai_use': 'Usar',
    'content_studio.ai_estimated_fast': '~2 segundos...',
    'content_studio.ai_estimated_slow': '~20 segundos...',
    'content_studio.ai_gen_retry': 'Reintentar',
    'content_studio.ai_gen_open_dashboard': 'Abrir panel FAL',
    'content_studio.carousel.template': 'Plantilla',
    'content_studio.carousel.no_template': 'Sin plantilla',
    'content_studio.carousel.hook': 'Hook',
    'content_studio.carousel.cta': 'CTA',
    'content_studio.carousel.rewrite_slide': 'Reescribir',
    'content_studio.carousel.generate_image': 'Generar imagen',
    'content_studio.carousel.insert_after': '+ Slide',
    'content_studio.carousel.caption_label': 'Caption',
    'content_studio.carousel.hashtags_label': 'Hashtags',
    'content_studio.carousel.save_caption': 'Guardar',
    'content_studio.carousel.rewrite_caption': 'Reescribir ↻',
    'content_studio.carousel.confirm_template_change': 'Cambiar plantilla eliminará todas las imágenes generadas. ¿Continuar?',
    'content_studio.carousel.stale_banner': 'La marca cambió desde el último renderizado. Vuelve a renderizar para actualizar.',
    'content_studio.layout.split': 'Split',
    'content_studio.layout.overlay': 'Overlay',
    'content_studio.layout.card': 'Card',
    'content_studio.layout.minimal_gradient': 'Gradiente',
    'content_studio.layout.vertical_split': 'Vertical',
    'content_studio.layout.sticky_note': 'Nota',
    'content_studio.layout.checklist': 'Checklist',
    'content_studio.layout.logo': 'Logo',
    'content_studio.layout.default': 'Predeterminado',
    'content_studio.no_stock_results': 'No se encontraron resultados.',
    'content_studio.suggest_alternatives': 'Sugerir alternativas',
    'content_studio.alt_loading': 'Cargando alternativas...',
    'stock_search.results_from': 'Resultados de {source}',
    'stock_search.fallback_used': '{primary} no disponible, mostrando resultados de {fallback}',
    'stock_search.not_configured': 'API de fotos de stock no configurada',
    'stock_search.auth_failed': 'Clave API inválida',
    'stock_search.rate_limited': 'Límite de solicitudes alcanzado, inténtalo más tarde',
    'stock_search.api_error': 'Error de API',
    'stock_search.network_error': 'Error de red',
    'stock_search.enrichment_failed': 'Optimización de palabras clave fallida',
    // Outreach
    'outreach.phase.kalt': 'Frío',
    'outreach.phase.interesse': 'Interés',
    'outreach.phase.vertiefung': 'Profundización',
    'outreach.phase.closing': 'Cierre',
    'outreach.state.nicht_verbunden': 'Sin conexión',
    'outreach.state.angefragt': 'Solicitud enviada',
    'outreach.state.abgelehnt': 'Rechazado',
    'outreach.state.verbunden': 'Conectado',
    'outreach.state.angeschrieben': 'Contactado',
    'outreach.state.geghosted': 'Sin respuesta',
    'outreach.state.geantwortet': 'Respondió',
    'outreach.state.termin': 'Reunión',
    'outreach.substate.konkrete_frage': 'Pregunta concreta',
    'outreach.substate.legitimitaetstest': 'Prueba de legitimidad',
    'outreach.substate.gegenfrage': 'Contrapregunta',
    'outreach.substate.persoenliche_oeffnung': 'Apertura personal',
    'outreach.substate.einwand_preis': 'Objeción: precio',
    'outreach.substate.einwand_timing': 'Objeción: momento',
    'outreach.substate.einwand_fit': 'Objeción: encaje',
    'outreach.substate.weiterleitung': 'Derivación',
    'outreach.substate.absage': 'Negativa',
    'outreach.state.empty': 'Aún no hay textos para este estado.',
    'outreach.state.oldPhase': 'Fase anterior',
    'outreach.state.connectors': 'Conectores (encajan en cualquier estado)',
    'outreach.review.title': '¿Cómo fue la respuesta?',
    'outreach.review.fire': 'Excelente',
    'outreach.review.ok': 'Ok',
    'outreach.review.weak': 'Débil',
    'outreach.review.no_reply': 'Sin respuesta',
    'outreach.review.their_response': '¿Qué respondió? (opcional)',
    'outreach.review.saved': '¡Evaluación guardada!',
    'outreach.review.not_sent': 'No lo envié · deshacer',
    'outreach.used_badge': '{count}\u00d7 esta semana',
    'outreach.platform.linkedin': 'LinkedIn',
    'outreach.platform.email': 'E-Mail',
    'outreach.platform.instagram': 'Instagram',
    'outreach.platform.andere': 'Otro',
    'outreach.platform.add': 'Agregar plataforma',
    'outreach.style.casual': 'Casual',
    'outreach.style.professional': 'Profesional',
    'outreach.style.direkt': 'Directo',
    'outreach.style.empathisch': 'Empático',
    'outreach.enrichment.ig_profile': 'Perfil IG',
    'outreach.enrichment.website': 'Sitio web',
    'outreach.enrichment.competitors': 'Competencia',
    'outreach.enrichment.strategy': 'Estrategia',
    'outreach.enrichment.upload_screenshot': 'Subir captura',
    'outreach.enrichment.analyze': 'Analizar',
    'outreach.enrichment.history': 'Historial',
    'outreach.enrichment.notes': 'Notas',
    'outreach.enrichment.auto_fetch': 'Auto-Fetch',
    'outreach.enrichment.manual': 'Manual',
    'outreach.enrichment.search_competitors': 'Buscar',
    'outreach.enrichment.linked': 'vinculada',
    'outreach.enrichment.analyzed': 'analizado',
    'outreach.enrichment.competitors_found': '{count} competidores',
    'outreach.enrichment.loading': 'Analizando...',
    'outreach.target.new': 'Nuevo objetivo',
    'outreach.target.company_name': 'Nombre empresa',
    'outreach.target.ig_username': 'Usuario IG',
    'outreach.target.platforms': 'Plataformas',
    'outreach.target.strategy': 'Estrategia',
    'outreach.target.website': 'Sitio web',
    // Sales CRM
    'nav.sales_crm': 'Sales CRM',
    'nav.outreach': 'Business Outreach',
    'sales.listbuilding': 'Listado',
    'sales.tracking': 'Seguimiento',
    'sales.add_lead': 'Agregar Lead',
    'sales.call': 'Llamar',
    'sales.start_call': 'Iniciar Llamada',
    'sales.submit_call': 'Guardar Llamada',
    'sales.update_status_prompt': '¿Actualizar estado del lead?',
    'sales.follow_up_date': 'Fecha de Seguimiento',
    'sales.script_editor': 'Editar Script',
    'sales.kpi.total_calls': 'Llamadas Totales',
    'sales.kpi.won': 'Ganado',
    'sales.kpi.lost': 'Perdido',
    'sales.kpi.conversion': 'Conversión %',
    'sales.emotion.warm': 'Cálido',
    'sales.emotion.neutral': 'Neutral',
    'sales.emotion.cold': 'Frío',
    'sales.emotion.hostile': 'Hostil',
    'sales.source.linkedin': 'LinkedIn',
    'sales.source.instagram': 'Instagram',
    'sales.source.referral': 'Referido',
    'sales.source.cold': 'Frío',
    'sales.source.website': 'Sitio Web',
    'sales.status.new': 'Nuevo',
    'sales.status.called': 'Llamado',
    'sales.status.follow_up': 'Seguimiento',
    'sales.status.won': 'Ganado',
    'sales.status.lost': 'Perdido',
    'sales.pre_call_summary': 'Resumen Pre-Llamada',
    'sales.no_previous_calls': 'Primera Llamada',
    'sales.script_save': 'Guardar Script',
    'sales.version_history': 'Historial de Versiones',
    'sales.restore_version': 'Restaurar',
    'strategy.field.niche.problemsAndDesires': 'Problemas, miedos y deseos por nicho',
    'strategy.field.niche.mostPowerfulProblem': 'El único problema o deseo más poderoso',
    'strategy.field.niche.transformationBefore': 'Estado actual (antes) · ¿dónde están ahora?',
    'strategy.field.niche.transformationAfter': 'Estado deseado (después) · ¿a dónde quieren ir?',
    'strategy.field.market.q1': '¿Qué los mantiene despiertos de noche?',
    'strategy.field.market.q2': '¿A qué le tienen miedo?',
    'strategy.field.market.q3': '¿Qué les enoja? ¿A quién?',
    'strategy.field.market.q4': 'Top 3 frustraciones diarias',
    'strategy.field.market.q5': '¿Qué tendencias hay en su área?',
    'strategy.field.market.q6': '¿Qué desean secretamente más?',
    'strategy.field.market.q7': '¿Hay un sesgo en cómo toman decisiones?',
    'strategy.field.market.q8': '¿Tienen su propio lenguaje o jerga?',
    'strategy.field.market.q9': '¿Quién más vende algo similar? ¿Cómo?',
    'strategy.field.market.q10': '¿Quién intentó vender algo similar y fracasó? ¿Por qué?',
    'strategy.field.avatar.name': 'Nombre del avatar',
    'strategy.field.avatar.occupation': 'Ocupación o título descriptivo',
    'strategy.field.avatar.location': '¿Dónde viven?',
    'strategy.field.avatar.age': '¿Qué edad tienen?',
    'strategy.field.avatar.education': 'Nivel de educación',
    'strategy.field.avatar.accomplishments': '¿Qué han logrado?',
    'strategy.field.avatar.weeklyRoutine': '¿Cómo pasan su semana?',
    'strategy.field.avatar.outsideWork': '¿Qué hacen fuera del trabajo?',
    'strategy.field.avatar.newsSources': '¿Dónde obtienen información?',
    'strategy.field.avatar.income': '¿Cuánto ganan?',
    'strategy.field.avatar.jobFeelings': '¿Cómo se sienten con su trabajo?',
    'strategy.field.avatar.lifeConcerns': '¿Cuáles son sus preocupaciones?',
    'strategy.field.avatar.marketingPersonality': 'Aspectos de personalidad que afectan el marketing',
    'strategy.field.avatar.backstory': 'Eventos pasados que llevaron a este punto',
    'strategy.field.avatar.pastFeelings': 'Cómo se sienten sobre el pasado',
    'strategy.field.avatar.currentInterests': 'En qué están interesados actualmente',
    'strategy.field.avatar.relationshipStatus': '¿Casado/divorciado/soltero/hijos?',
    'strategy.field.avatar.familyImpact': 'Cómo la familia afecta el uso del producto',
    'strategy.field.avatar.whyProductMatters': '¿Cómo resuelve tu producto su necesidad?',
    'strategy.field.avatar.purchaseTrigger': '¿Cuál es el "detonante final" que los hace comprar?',
    'strategy.field.archetype.failure_scene': '¿Cuál es la escena exacta del fracaso? (UN momento concreto, presente, máx. 2 frases)',
    'strategy.field.archetype.identity_tension': '¿Qué cree el espectador sobre sí mismo que contradice sus resultados?',
    'strategy.field.archetype.insight_gap': '¿Qué no está dispuesto a admitir el espectador?',
    'strategy.field.archetype.winning_scene': '¿Cómo se ve "ganar" como una escena concreta y visual?',
    'strategy.field.mvo.niche': '¿Cuál es el nicho?',
    'strategy.field.mvo.currentSituation': 'Situación actual',
    'strategy.field.mvo.desiredSituation': 'Situación deseada',
    'strategy.field.mvo.costOfStaying': '¿Qué les cuesta quedarse?',
    'strategy.field.mvo.worthOfGetting': '¿Cuánto valdría llegar allí?',
    'strategy.field.mvo.whatParticipantsDo': '¿Qué hacen la mayoría de los participantes?',
    'strategy.field.mvo.whatProvidersDo': '¿Qué ofrecen los proveedores?',
    'strategy.field.mvo.whatCrushersDo': '¿Qué hacen los top performers? ¿Qué los diferencia?',
    'strategy.field.offer.niche': '¿Cuál es el nicho?',
    'strategy.field.offer.currentSituation': 'Situación actual',
    'strategy.field.offer.desiredSituation': 'Situación deseada',
    'strategy.field.offer.versionNumber': 'Número de versión',
    'strategy.field.offer.signalVsNoise': 'Señal vs Ruido',
    'strategy.field.offer.minimumWork': 'Trabajo mínimo requerido para la transformación',
    'strategy.field.offer.price': 'Precio justo pero alto',
    'strategy.field.offer.certaintyOfNiche': '¿Qué tan seguro estás del nicho? (1-10)',
    'strategy.field.offer.painLevel': '¿Cuán dolorosa es su situación actual? (1-10)',
    'strategy.field.offer.urgencyLevel': '¿Cuán urgente es su deseo? (1-10)',
    'strategy.field.offer.complexityLevel': '¿Cuán compleja es la solución? (1=complejo, 10=simple)',
    'strategy.field.offer.possibilityLevel': '¿Cuán posible es alcanzar la situación deseada? (1-10)',
    'strategy.field.offer.timeframeDays': 'Plazo en días',
    'strategy.field.offer.separator': 'Parte 2: Feedback del Mercado en Vivo',
    'strategy.field.offer.offersCount': 'Número de ofertas hechas (objetivo: 30+)',
    'strategy.field.offer.objections': '¿Qué objeciones da el mercado?',
    'strategy.field.offer.thingsLiked': '¿Qué le gusta al mercado?',
    'strategy.field.offer.conversationConclusions': '¿Cómo terminan las conversaciones?',
    'strategy.field.offer.emergingPatterns': '¿Qué patrones se repiten?',
    'strategy.field.offer.improvements': 'Formas de mejorar tu hipótesis',
    'strategy.field.message.niche': '¿Cuál es el nicho?',
    'strategy.field.message.currentSituation': 'Situación actual',
    'strategy.field.message.desiredSituation': 'Situación deseada',
    'strategy.field.message.versionNumber': 'Número de versión',
    'strategy.field.message.nicheLanguage': 'Lenguaje/jerga del nicho',
    'strategy.field.message.messageEquation': '"Ayudo a [nicho] a [obtener resultado] mediante [oferta]"',
    'strategy.field.message.preResonanceScore': 'Calificación de resonancia antes del feedback (1-10)',
    'strategy.field.message.separator': 'Parte 2: Feedback del Mercado en Vivo',
    'strategy.field.message.offersCount': 'Número de ofertas hechas',
    'strategy.field.message.repeatedPhrases': 'Palabras/frases que los prospectos repiten',
    'strategy.field.message.recurringStories': 'Historias que se repiten',
    'strategy.field.message.metaphorsUsed': 'Metáforas/analogías que usan los prospectos',
    'strategy.field.message.boredTopics': '¿Qué los aburre o entristece?',
    'strategy.field.message.excitedTopics': '¿Qué los emociona o energiza?',
    'strategy.field.message.wordsNotResonated': 'Tus palabras que NO resonaron',
    'strategy.field.message.wordsResonated': 'Tus palabras que SÍ resonaron',
    'strategy.field.message.bestMetaphors': 'Tus mejores metáforas/analogías',
    'strategy.field.message.postResonanceScore': 'Calificación de resonancia después del feedback (1-10)',
    'strategy.field.message.improvements': 'Formas de mejorar tu hipótesis de mensaje',
    // Visual Identity module
    'strategy.module.visual': 'Identidad Visual',
    'strategy.field.visual.visual_style': 'Estilo Visual',
    'strategy.field.visual.photo_style': 'Estilo de Foto',
    'strategy.field.visual.preferred_templates': 'Plantillas Preferidas',
    'strategy.field.visual.color_usage': 'Uso de Colores',
    'strategy.field.visual.image_mood': 'Ambiente de Imagen',
    'strategy.field.visual.content_format_mix': 'Mix de Formatos',
    'strategy.field.visual.photo_pool': 'Pool de Fotos',
    'strategy.field.visual.use_photos_for_carousel': 'Usar Fotos Propias para Hook del Carrusel (Slide 1)',
    'strategy.field.visual.photo_pool_source': 'Fuente de Fotos',
    'strategy.field.visual.photo_pool_drive_folder_id': 'ID de Carpeta Google Drive',
    'strategy.field.visual.photo_overlay_opacity': 'Opacidad del Overlay',
    'strategy.field.visual.logo_url': 'Logo',
    'strategy.field.visual.logo_shape': 'Forma del Logo',
    'strategy.field.visual.logo_border_width': 'Ancho del Borde',
    'strategy.field.visual.logo_border_color': 'Color del Borde',
    'strategy.field.visual.logo_size': 'Tamaño del Logo',
    'strategy.field.visual.brand_identity': 'Identidad de Marca',
    'strategy.field.visual.brand_aesthetic': 'Estética de Marca',
    'strategy.field.visual.face_style_prompt': 'Estilo de Rostro',
    'strategy.field.visual.profile_pic_prompt': 'Guía de Foto de Perfil',
    'strategy.field.visual.color_palette': 'Colores de Marca',
    'content_studio.logo_settings': 'Config. del Logo',
    'content_studio.logo_size': 'Tamaño del Logo',
    'content_studio.border_width': 'Ancho del Borde',
    'content_studio.border_color': 'Color del Borde',
    // Audit
    'audit.tab': 'Auditoría',
    'audit.generate_tab': 'Generar',
    'audit.history_tab': 'Historial',
    'audit.upload_profile': 'Captura de Perfil',
    'audit.upload_feed': 'Grid del Feed (opcional)',
    'audit.drop_hint': 'Haz clic, arrastra o Cmd+V',
    'audit.run_button': 'Auditar Perfil',
    'audit.overall_score': 'Puntuación General',
    'audit.top_priorities': 'Prioridades Principales',
    'audit.status_green': 'Bien',
    'audit.status_yellow': 'Mejorable',
    'audit.status_red': 'Crítico',
    'audit.status_concern': 'Conflicto de Estrategia',
    'audit.apply': 'Aplicar',
    'audit.refine': 'Refinar con IA',
    'audit.feed_analysis': 'Análisis del Feed',
    'audit.no_audits': 'Aún no hay auditorías',
    'audit.loading': 'Analizando...',
    'audit.current_profile': 'Perfil Actual',
    'audit.current_profile_empty': 'Sin datos de perfil · realiza un audit o ingresa manualmente',
    'audit.current_profile_source': 'Fuente',
    'audit.action_to_kit': '→ Al Kit',
    'audit.action_implemented': '✓ Implementado',
    'audit.action_dismiss': 'Descartar',
    'audit.action_custom': 'Personalizar',
    'audit.implementation_score': '{done}/{total} implementado',
    'audit.custom_placeholder': 'Tu versión...',
    'audit.improve_disabled': 'Crea primero un perfil via auditoría de captura o añade campos manualmente',
    'audit.seo_chars': '{n}/64 caracteres',
    'audit.seo_too_long': 'Máx 64 caracteres!',
    'audit.save': 'Guardar',
    'audit.profile_screenshot': 'Captura de Perfil',
    'audit.feed_screenshot': 'Grid del Feed (opcional)',
    'audit.run': 'Auditar Perfil',
    'audit.field_results': 'Campos',
    'audit.show_history': 'Ver Historial',
    'audit.no_history': 'Aún no hay auditorías',
    'audit.platform_instagram': 'Instagram',
    'audit.platform_linkedin': 'LinkedIn',
    'audit.platform_landingpage': 'Landing Page',
    'audit.optimization': 'Optimización',
    'audit.strategy_fit': 'Ajuste Estratégico',
    'audit.lp_url_label': 'Ingresar URL',
    'audit.lp_url_placeholder': 'https://tu-sitio.com',
    'audit.lp_loading_screenshot': 'Generando captura...',
    'audit.lp_screenshot': 'Captura (obligatoria)',
    'audit.banner_upload': 'Banner (opcional)',
    'audit.concern_warning': 'Este cambio puede entrar en conflicto con tu estrategia. ¿Aplicar de todos modos?',
    'audit.concern_confirm': 'Aplicar de todos modos',
    'audit.concern_cancel': 'Cancelar',
    'audit.field_headline': 'Titular',
    'audit.field_about': 'Acerca de',
    'audit.field_featured': 'Destacado',
    'audit.field_banner': 'Banner',
    'audit.field_subheadline': 'Subtítulo',
    'audit.field_cta': 'Llamada a la Acción',
    'audit.field_social_proof': 'Prueba Social',
    'audit.field_visual_identity': 'Identidad Visual',
    'audit.field_conversion_structure': 'Estructura de Conversión',
    'audit.field_strategy_alignment': 'Alineación Estratégica',
    'profile_overview.title': 'Mi Perfil',
    'profile_overview.empty': 'Sin perfil aún. Genera un kit y adopta campos.',
    'profile_overview.remove': 'Eliminar',
    'profile_overview.edit': 'Editar',
    'profile_overview.save': 'Guardar',
    'profile_overview.adopted': 'Adoptado',
    'profile_overview.last_audit': 'Último Audit',
    'profile_overview.no_audit': 'Sin Audit',
    'profile_overview.add_field': 'Añadir campo',
    'profile_overview.select_field': 'Seleccionar campo...',
    'profile_overview.cancel': 'Cancelar',
    'settings.branding_title': 'Marca',
    'settings.app_name': 'Nombre de la app',
    'settings.logo': 'Logo',
    'settings.upload_logo': 'Subir logo',
    'settings.primary_color': 'Color primario',
    'settings.accent_color': 'Color de acento',
    'settings.save': 'Guardar',
    'settings.saved': 'Guardado',
    'brand.profile': 'Perfil',
    'brand.channels': 'Canales',
    'brand.competitors': 'Competidores',
    'brand.display_name': 'Nombre de la marca',
    'brand.entity_type': 'Tipo',
    'brand.industry': 'Industria',
    'brand.website': 'Sitio web',
    'brand.description': 'Descripción',
    'brand.entity_person': 'Persona',
    'brand.entity_business': 'Empresa',
    'brand.entity_brand': 'Marca',
    'brand.add_channel': 'Añadir canal',
    'brand.edit_channel': 'Editar canal',
    'brand.set_primary': 'Establecer como primario',
    'brand.remove_channel': 'Eliminar canal',
    'brand.primary': 'Primario',
    'brand.platform_instagram': 'Instagram',
    'brand.platform_youtube': 'YouTube',
    'brand.platform_linkedin': 'LinkedIn',
    'brand.platform_tiktok': 'TikTok',
    'brand.platform_website': 'Sitio web',
    'brand.platform_landing_page': 'Página de destino',
    'brand.add_competitor': 'Añadir competidor',
    'brand.remove_competitor': 'Eliminar competidor',
    'brand.scraping': 'Extrayendo...',
    'brand.scrape_apify': 'Extraer via Apify',
    'brand.check_account': 'Verificar cuenta',
    'brand.account_exists': 'ya existe',
    'brand.account_not_found': 'no encontrado',
    'brand.benchmark': 'Benchmark',
    'brand.benchmark_better': 'Mejor',
    'brand.benchmark_worse': 'Peor',
    'brand.create_new': 'Crear nueva marca',
    'brand.select_existing': 'Seleccionar marca existente',
    'brand.no_brand': 'Sin marca vinculada',
    'brand.no_channels': 'Sin canales aún',
    'nav.integrations': 'Integraciones',
    'integrations.title': 'Integraciones',
    'integrations.connected_accounts': 'Cuentas conectadas',
    'integrations.ig_connect': 'Conectar Instagram',
    'integrations.ig_connect_other': 'Conectar otra cuenta',
    'integrations.ig_disconnect': 'Desconectar',
    'integrations.ig_connected_success': '¡Instagram conectado con éxito!',
    'integrations.ig_connect_error': 'Conexión fallida. Por favor inténtalo de nuevo.',
    'integrations.ig_no_connections': 'No hay cuentas de Instagram conectadas.',
    'integrations.ig_publish_history': 'Historial de publicaciones',
    'integrations.ig_token_active': 'Activo',
    'integrations.ig_token_expiring': 'Expira pronto',
    'integrations.ig_token_expired': 'Expirado',
    'content_studio.publish_ig': 'Publicar en IG',
    'content_studio.publish_ig_publishing': 'Publicando...',
    'content_studio.publish_ig_success': '¡Publicado en Instagram!',
    'content_studio.publish_ig_failed': 'Publicación fallida',
    'content_studio.publish_ig_select_account': 'Seleccionar cuenta',
    'content_studio.publish_ig_already_published': 'Ya publicado',
    'content_studio.trending_audio_tip': 'Consejo: los carousels con audio trending tienen opción de aparecer en la pestaña Reels (hasta 10x de alcance). El audio se añade manualmente en Instagram.',
    'content_studio.trending_audio_link': 'Ver audios trending',
    // Satellite OS
    'nav.satellite_os': 'Satellite OS',
    // Content Vault
    'nav.vault': 'Content Vault',
    'nav.trending_music': 'Trending Music',
    'nav.reels': 'Reels',
    'nav.contact_pool': 'Contact Pool',
    'nav.group_content_engine': 'Content Engine',
    'nav.group_strategy': 'Estrategia',
    'nav.group_sales_outreach': 'Ventas y Alcance',
    'nav.group_system': 'Sistema',
    'satellite.tab.dashboard': 'Dashboard',
    'satellite.tab.detail': 'Detalle',
    'satellite.tab.leads': 'Embudo de Leads',
    'satellite.status.setup': 'Configurando',
    'satellite.status.growing': 'Creciendo',
    'satellite.status.monetizing': 'Monetizando',
    'satellite.status.sold': 'Vendido',
    'satellite.status.archived': 'Archivado',
    'satellite.fork_button': 'Fork como Satellite',
    'satellite.create': 'Crear Satellite',
    'satellite.name': 'Nombre',
    'satellite.origin_strategy': 'Estrategia Origen',
    'satellite.select_strategy': 'Seleccionar estrategia...',
    'satellite.mode': 'Modo',
    'satellite.monetization': 'Monetización',
    'satellite.bio_link': 'URL del Bio Link',
    'satellite.target_followers': 'Objetivo de Seguidores',
    'satellite.revenue_target': 'Objetivo de Ingresos',
    'satellite.link_account': 'Vincular Cuenta',
    'satellite.promote_to_crm': '→ CRM',
    'satellite.leads_count': 'Leads',
    'satellite.revenue': 'Ingresos',
    'satellite.no_satellites': 'Sin satellites todavía',
    'satellite.select_satellite': 'Seleccionar un satellite',
    'satellite.settings': 'Configuración',
    'satellite.no_leads': 'Sin leads todavía',
    'satellite.add_lead': 'Agregar Lead',
    'sse.connection_lost': 'Actualizaciones en vivo pausadas. Los datos pueden estar desactualizados.',
    'sse.reconnect': 'Reconectar',
    'ig.link_failed_warning': 'Instagram conectado, pero la vinculación automática falló. Por favor vincule manualmente.',
    'ig.disconnect_fetch_error': 'No se pudieron verificar los canales afectados.',
    'ig.no_ig_channels': 'No hay canales de Instagram disponibles',
    'ig.select_channel_first': 'Seleccione un canal primero',
    'ig.link_broken': 'Enlace roto',
    'ig.no_connection_linked': 'No hay cuenta de IG vinculada a este canal',
    'ig.connected_success_channel': 'Instagram conectado y vinculado!',
  },
};

export function t(key: string, lang: string = 'de'): string {
  return translations[lang]?.[key] ?? translations['de']?.[key] ?? key;
}

export default translations;
